/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSpkTeamMemberTbl = /* GraphQL */ `
  query GetSpkTeamMemberTbl($id: ID!) {
    getSpkTeamMemberTbl(id: $id) {
      id
      allSort
      loginEmail
      isolvedEmail
      firstName
      middleName
      lastName
      goesBy
      dob
      hireDate
      billableDivisionJobClassId
      billableDivisionJobClass {
        divisionPosition
        className
        appDisplayName
        invoiceDisplayName
        unionDisplayName
        hourlyRate
        overtimeRate
        divisionId
        isActive
        isHiddenByDefault
        createdAt
        updatedAt
        __typename
      }
      doTrackPunches
      djtHideByDefault
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      multiDivisions
      termDate
      imgUrl
      avatarId
      memberOf
      badgeNumber
      employmentCategoryCode
      employeeNumber
      leaveRequests {
        nextToken
        __typename
      }
      addStreet
      addCity
      addState
      addZipcode
      phoneNum
      isActive
      isLocked
      isGlobalAdmin
      emergcyContName
      emergcyContPhone
      emergcyContSecName
      emergcyContSecPhone
      canTransfer
      isOnboarded
      isERPUser
      priviledged {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkTeamMemberTbls = /* GraphQL */ `
  query ListSpkTeamMemberTbls(
    $filter: ModelSpkTeamMemberTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkTeamMemberTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const getQBOConnectionMeta = /* GraphQL */ `
  query GetQBOConnectionMeta($id: ID!) {
    getQBOConnectionMeta(id: $id) {
      id
      realmId
      environment
      connectedByUserId
      connectedAt
      expiresAt
      lastRefreshAt
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listQBOConnectionMetas = /* GraphQL */ `
  query ListQBOConnectionMetas(
    $filter: ModelQBOConnectionMetaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQBOConnectionMetas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        realmId
        environment
        connectedByUserId
        connectedAt
        expiresAt
        lastRefreshAt
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTJobClassRateTbl = /* GraphQL */ `
  query GetSpkDJTJobClassRateTbl($divisionPosition: String!) {
    getSpkDJTJobClassRateTbl(divisionPosition: $divisionPosition) {
      divisionPosition
      className
      appDisplayName
      invoiceDisplayName
      unionDisplayName
      hourlyRate
      overtimeRate
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      isActive
      isHiddenByDefault
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTJobClassRateTbls = /* GraphQL */ `
  query ListSpkDJTJobClassRateTbls(
    $divisionPosition: String
    $filter: ModelSpkDJTJobClassRateTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkDJTJobClassRateTbls(
      divisionPosition: $divisionPosition
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        divisionPosition
        className
        appDisplayName
        invoiceDisplayName
        unionDisplayName
        hourlyRate
        overtimeRate
        divisionId
        isActive
        isHiddenByDefault
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDivisionTbl = /* GraphQL */ `
  query GetSpkDivisionTbl($id: ID!) {
    getSpkDivisionTbl(id: $id) {
      id
      allSort
      regionId
      isFeeder
      prettyId
      prettyname
      defaultQBClass
      addStreet
      addCity
      addState
      addZipcode
      teamMembers {
        nextToken
        scannedCount
        count
        __typename
      }
      superVisorId
      supervisor {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      asstSupervisorId
      asstSupervisor {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      djtCanPerDiem
      djtPerDiemAmt
      djtTrackLabor
      djtTrackEquipment
      djtTrackMaterial
      djtRentalMsgActive
      djtRentalMsg
      djtAllowsWO
      djtOneClient
      djtAllowsEmailCC
      djtDefaultStartTime
      djtDefaultEndTime
      djtDefaultLunchDuration
      djtEnableAllSupervisors
      djtMergeMaterialEquipment
      djtShowDownloadPDF
      laborMultiplier
      isActive
      isSafeInspection
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDivisionTbls = /* GraphQL */ `
  query ListSpkDivisionTbls(
    $filter: ModelSpkDivisionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDivisionTbls(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkLeaveRequestTbl = /* GraphQL */ `
  query GetSpkLeaveRequestTbl($id: ID!) {
    getSpkLeaveRequestTbl(id: $id) {
      id
      name
      employeeNumber
      leaveDate
      category
      hours
      status
      requestDateTime
      dateApproved
      department
      modifiedBy
      comments
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkLeaveRequestTbls = /* GraphQL */ `
  query ListSpkLeaveRequestTbls(
    $filter: ModelSpkLeaveRequestTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkLeaveRequestTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        employeeNumber
        leaveDate
        category
        hours
        status
        requestDateTime
        dateApproved
        department
        modifiedBy
        comments
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkTeamMemberPrivilegedTbl = /* GraphQL */ `
  query GetSpkTeamMemberPrivilegedTbl($id: ID!) {
    getSpkTeamMemberPrivilegedTbl(id: $id) {
      id
      teamMemberId
      docDataTypeId
      docDataType {
        id
        type
        isActive
        createdAt
        updatedAt
        __typename
      }
      uploadedDocumentId
      uploadedDocument {
        id
        identityId
        key
        bucket
        owner
        createdAt
        updatedAt
        __typename
      }
      identityDocumentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkTeamMemberPrivilegedTbls = /* GraphQL */ `
  query ListSpkTeamMemberPrivilegedTbls(
    $filter: ModelSpkTeamMemberPrivilegedTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkTeamMemberPrivilegedTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teamMemberId
        docDataTypeId
        uploadedDocumentId
        identityDocumentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTLaborPopularityTbl = /* GraphQL */ `
  query GetSpkDJTLaborPopularityTbl($departmentEmployeeNumber: String!) {
    getSpkDJTLaborPopularityTbl(
      departmentEmployeeNumber: $departmentEmployeeNumber
    ) {
      departmentEmployeeNumber
      department
      employeeNumber
      popularity
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTLaborPopularityTbls = /* GraphQL */ `
  query ListSpkDJTLaborPopularityTbls(
    $departmentEmployeeNumber: String
    $filter: ModelSpkDJTLaborPopularityTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkDJTLaborPopularityTbls(
      departmentEmployeeNumber: $departmentEmployeeNumber
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        departmentEmployeeNumber
        department
        employeeNumber
        popularity
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDocumentDataTypeTbl = /* GraphQL */ `
  query GetSpkDocumentDataTypeTbl($id: ID!) {
    getSpkDocumentDataTypeTbl(id: $id) {
      id
      type
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDocumentDataTypeTbls = /* GraphQL */ `
  query ListSpkDocumentDataTypeTbls(
    $filter: ModelSpkDocumentDataTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDocumentDataTypeTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUploadedDocumentTbl = /* GraphQL */ `
  query GetSpkUploadedDocumentTbl($id: ID!) {
    getSpkUploadedDocumentTbl(id: $id) {
      id
      identityId
      key
      bucket
      transactions {
        nextToken
        __typename
      }
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUploadedDocumentTbls = /* GraphQL */ `
  query ListSpkUploadedDocumentTbls(
    $filter: ModelSpkUploadedDocumentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkUploadedDocumentTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        identityId
        key
        bucket
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTUnitPopularityTbl = /* GraphQL */ `
  query GetSpkDJTUnitPopularityTbl($divisionIdUnitId: String!) {
    getSpkDJTUnitPopularityTbl(divisionIdUnitId: $divisionIdUnitId) {
      divisionIdUnitId
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      popularity
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTUnitPopularityTbls = /* GraphQL */ `
  query ListSpkDJTUnitPopularityTbls(
    $divisionIdUnitId: String
    $filter: ModelSpkDJTUnitPopularityTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkDJTUnitPopularityTbls(
      divisionIdUnitId: $divisionIdUnitId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        divisionIdUnitId
        divisionId
        unitId
        popularity
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTEmployeePopularityTbl = /* GraphQL */ `
  query GetSpkDJTEmployeePopularityTbl(
    $department: String!
    $employeeNumber: String!
  ) {
    getSpkDJTEmployeePopularityTbl(
      department: $department
      employeeNumber: $employeeNumber
    ) {
      department
      employeeNumber
      deptEmpComposite
      popularity
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTEmployeePopularityTbls = /* GraphQL */ `
  query ListSpkDJTEmployeePopularityTbls(
    $department: String
    $employeeNumber: ModelStringKeyConditionInput
    $filter: ModelSpkDJTEmployeePopularityTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkDJTEmployeePopularityTbls(
      department: $department
      employeeNumber: $employeeNumber
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        department
        employeeNumber
        deptEmpComposite
        popularity
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDailyJobTicketTbl = /* GraphQL */ `
  query GetSpkDailyJobTicketTbl($id: ID!) {
    getSpkDailyJobTicketTbl(id: $id) {
      id
      isActive
      isDuplicate
      isParent
      duplicateOfId
      parentId
      teamMemberId
      teamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      createDateTime
      djtDivisionTeamMember
      djtDivisionTeamMemberClient
      djtDateDivison
      djtDate
      djtDivisionId
      djtDivision {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      djtClientId
      djtDivisionClient
      djtDivisionStatus
      djtDivisionTeamMemberStatus
      djtDivisionTeamMemberClientStatus
      djtDivisionClientStatus
      djtClient {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      djtClientContactId
      djtClientContact {
        id
        clientId
        name
        email
        emailVerified
        phone
        isActive
        createdAt
        updatedAt
        __typename
      }
      djtRequiresClientAuth
      djtClientAuthName
      djtClientAuthSignatureId
      djtClientAuthSignature {
        id
        identityId
        key
        bucket
        owner
        createdAt
        updatedAt
        __typename
      }
      djtSupervisorAuthName
      djtSupervisorAuthSignatureId
      djtSupervisorAuthSignature {
        id
        identityId
        key
        bucket
        owner
        createdAt
        updatedAt
        __typename
      }
      djtNonContractPO
      djtClientPO
      specialInstructions
      isEstimate
      doNotBill
      doNotBillDescription
      djtPendingPO
      djtPOid
      djtPO {
        id
        divisionId
        djtClientId
        po
        poDivisionClient
        poLocation
        divisionClientPOHash
        poDescription
        poNotes
        isClosed
        isActive
        createdAt
        updatedAt
        __typename
      }
      djtWO
      djtWODescription
      djtClientDateWOPO
      djtNotes
      djtLocation
      djtLabor {
        nextToken
        __typename
      }
      djtLaborTotal
      djtEquipment {
        nextToken
        __typename
      }
      djtEquipmentTotal
      djtMaterial {
        nextToken
        __typename
      }
      djtMaterialTotal
      djtTotalBilled
      djtBillingNotes
      isSubmitted
      isAuthorized
      authorizedById
      authorizedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      autorizedDateTime
      isExported
      exportedById
      exportedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      exportedDateTime
      isPaid
      isClosed
      isSubmitValid
      lastStep
      isPushedToQB
      pushedToQBBy
      pushedToQBDateTime
      currentStatusId
      currentStatus {
        id
        allSort
        order
        status
        statusCode
        statusGroup
        createdAt
        updatedAt
        __typename
      }
      pdfFilename
      attachableObjId
      showLaborHours
      isDeleted
      attachedContractId
      attachedContract {
        id
        name
        createDateTime
        clientId
        documentId
        createdById
        createdAt
        updatedAt
        __typename
      }
      contracts {
        nextToken
        __typename
      }
      bouncedAdminReason
      bouncedSupervisorRespone
      verifiedComplete
      verifiedById
      verifiedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      mergeMaterialEquipment
      invoiceNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDailyJobTicketTbls = /* GraphQL */ `
  query ListSpkDailyJobTicketTbls(
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDailyJobTicketTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTEquipmentTbl = /* GraphQL */ `
  query GetSpkDJTEquipmentTbl($id: ID!) {
    getSpkDJTEquipmentTbl(id: $id) {
      id
      djtId
      djt {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      isActive
      isPrimary
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      unitCode
      isCustom
      isAuxillary
      auxUnitId
      auxUnit {
        id
        djtId
        auxillaryUnitId
        djtEquipmnetId
        billableUnitRateTypeId
        billedForQuantity
        billedForPrice
        billedForAmount
        createdAt
        updatedAt
        __typename
      }
      isAuxChild
      auxChildOfParentId
      date
      billableDescription
      totalBilled
      requiresDriver
      drivers {
        nextToken
        __typename
      }
      requiresOperator
      operators {
        nextToken
        __typename
      }
      statusId
      status {
        id
        allSort
        order
        status
        statusCode
        statusGroup
        createdAt
        updatedAt
        __typename
      }
      quantity
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTEquipmentTbls = /* GraphQL */ `
  query ListSpkDJTEquipmentTbls(
    $filter: ModelSpkDJTEquipmentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTEquipmentTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        isActive
        isPrimary
        unitId
        unitCode
        isCustom
        isAuxillary
        auxUnitId
        isAuxChild
        auxChildOfParentId
        date
        billableDescription
        totalBilled
        requiresDriver
        requiresOperator
        statusId
        quantity
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTBillableAuxUnitTbl = /* GraphQL */ `
  query GetSpkDJTBillableAuxUnitTbl($id: ID!) {
    getSpkDJTBillableAuxUnitTbl(id: $id) {
      id
      djtId
      djt {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      auxillaryUnitId
      auxillaryUnit {
        id
        allSort
        name
        description
        isBillable
        rateDescription
        price
        priceCodeId
        isMaterialExpense
        isActive
        createdAt
        updatedAt
        __typename
      }
      djtEquipmnetId
      djtEquipment {
        id
        djtId
        isActive
        isPrimary
        unitId
        unitCode
        isCustom
        isAuxillary
        auxUnitId
        isAuxChild
        auxChildOfParentId
        date
        billableDescription
        totalBilled
        requiresDriver
        requiresOperator
        statusId
        quantity
        createdAt
        updatedAt
        __typename
      }
      billableUnitRateTypeId
      billableUnitRateType {
        id
        billAt
        createdAt
        updatedAt
        __typename
      }
      billedForQuantity
      billedForPrice
      billedForAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTBillableAuxUnitTbls = /* GraphQL */ `
  query ListSpkDJTBillableAuxUnitTbls(
    $filter: ModelSpkDJTBillableAuxUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTBillableAuxUnitTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        auxillaryUnitId
        djtEquipmnetId
        billableUnitRateTypeId
        billedForQuantity
        billedForPrice
        billedForAmount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTDriverTbl = /* GraphQL */ `
  query GetSpkDJTDriverTbl($id: ID!) {
    getSpkDJTDriverTbl(id: $id) {
      id
      djtId
      djt {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      unitId
      djtEquipmentId
      djtEquipment {
        id
        djtId
        isActive
        isPrimary
        unitId
        unitCode
        isCustom
        isAuxillary
        auxUnitId
        isAuxChild
        auxChildOfParentId
        date
        billableDescription
        totalBilled
        requiresDriver
        requiresOperator
        statusId
        quantity
        createdAt
        updatedAt
        __typename
      }
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      date
      drivenById
      drivenBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTDriverTbls = /* GraphQL */ `
  query ListSpkDJTDriverTbls(
    $filter: ModelSpkDJTDriverTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTDriverTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        drivenById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTOperatorTbl = /* GraphQL */ `
  query GetSpkDJTOperatorTbl($id: ID!) {
    getSpkDJTOperatorTbl(id: $id) {
      id
      djtId
      djt {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      djtEquipmentId
      djtEquipment {
        id
        djtId
        isActive
        isPrimary
        unitId
        unitCode
        isCustom
        isAuxillary
        auxUnitId
        isAuxChild
        auxChildOfParentId
        date
        billableDescription
        totalBilled
        requiresDriver
        requiresOperator
        statusId
        quantity
        createdAt
        updatedAt
        __typename
      }
      date
      operatedById
      operatedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTOperatorTbls = /* GraphQL */ `
  query ListSpkDJTOperatorTbls(
    $filter: ModelSpkDJTOperatorTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTOperatorTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        operatedById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkAuxillaryUnitTbl = /* GraphQL */ `
  query GetSpkAuxillaryUnitTbl($id: ID!) {
    getSpkAuxillaryUnitTbl(id: $id) {
      id
      allSort
      name
      description
      isBillable
      rateDescription
      price
      priceCodeId
      priceCode {
        priceCode
        price
        year
        rateTypeId
        name
        divisionId
        divisionYear
        createdAt
        updatedAt
        __typename
      }
      isMaterialExpense
      primaryUnits {
        nextToken
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkAuxillaryUnitTbls = /* GraphQL */ `
  query ListSpkAuxillaryUnitTbls(
    $filter: ModelSpkAuxillaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkAuxillaryUnitTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        description
        isBillable
        rateDescription
        price
        priceCodeId
        isMaterialExpense
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTDefaultBillableMaterialTbl = /* GraphQL */ `
  query GetSpkDJTDefaultBillableMaterialTbl($id: ID!) {
    getSpkDJTDefaultBillableMaterialTbl(id: $id) {
      id
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      order
      description
      notes
      price
      quantity
      isActive
      doShowOnLoad
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTDefaultBillableMaterialTbls = /* GraphQL */ `
  query ListSpkDJTDefaultBillableMaterialTbls(
    $filter: ModelSpkDJTDefaultBillableMaterialTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTDefaultBillableMaterialTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        divisionId
        order
        description
        notes
        price
        quantity
        isActive
        doShowOnLoad
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkStatementVendorMapTbl = /* GraphQL */ `
  query GetSpkStatementVendorMapTbl($vendorName: String!) {
    getSpkStatementVendorMapTbl(vendorName: $vendorName) {
      vendorName
      vendorTypeKey
      vendorType {
        vendorType
        allSort
        appDisplayName
        createdAt
        updatedAt
        __typename
      }
      sellsDiesel
      qbVendorId
      qbVendor {
        qbId
        allSort
        qbDisplayName
        qbDisplayNameLower
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkStatementVendorMapTbls = /* GraphQL */ `
  query ListSpkStatementVendorMapTbls(
    $vendorName: String
    $filter: ModelSpkStatementVendorMapTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkStatementVendorMapTbls(
      vendorName: $vendorName
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        vendorName
        vendorTypeKey
        sellsDiesel
        qbVendorId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkStatementQuickBooksVendorTbl = /* GraphQL */ `
  query GetSpkStatementQuickBooksVendorTbl($qbId: String!) {
    getSpkStatementQuickBooksVendorTbl(qbId: $qbId) {
      qbId
      allSort
      qbDisplayName
      qbDisplayNameLower
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkStatementQuickBooksVendorTbls = /* GraphQL */ `
  query ListSpkStatementQuickBooksVendorTbls(
    $qbId: String
    $filter: ModelSpkStatementQuickBooksVendorTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkStatementQuickBooksVendorTbls(
      qbId: $qbId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        qbId
        allSort
        qbDisplayName
        qbDisplayNameLower
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkStatementVendorMapTypeTbl = /* GraphQL */ `
  query GetSpkStatementVendorMapTypeTbl($vendorType: String!) {
    getSpkStatementVendorMapTypeTbl(vendorType: $vendorType) {
      vendorType
      allSort
      appDisplayName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkStatementVendorMapTypeTbls = /* GraphQL */ `
  query ListSpkStatementVendorMapTypeTbls(
    $vendorType: String
    $filter: ModelSpkStatementVendorMapTypeTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkStatementVendorMapTypeTbls(
      vendorType: $vendorType
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        vendorType
        allSort
        appDisplayName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkStatementStatusTbl = /* GraphQL */ `
  query GetSpkStatementStatusTbl($statementStatus: String!) {
    getSpkStatementStatusTbl(statementStatus: $statementStatus) {
      statementStatus
      allSort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkStatementStatusTbls = /* GraphQL */ `
  query ListSpkStatementStatusTbls(
    $statementStatus: String
    $filter: ModelSpkStatementStatusTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkStatementStatusTbls(
      statementStatus: $statementStatus
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        statementStatus
        allSort
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkStatementDocumentUnitTbl = /* GraphQL */ `
  query GetSpkStatementDocumentUnitTbl($id: ID!) {
    getSpkStatementDocumentUnitTbl(id: $id) {
      id
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      transactionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkStatementDocumentUnitTbls = /* GraphQL */ `
  query ListSpkStatementDocumentUnitTbls(
    $filter: ModelSpkStatementDocumentUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkStatementDocumentUnitTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        transactionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkCreditCardTeamMemberMapTbl = /* GraphQL */ `
  query GetSpkCreditCardTeamMemberMapTbl($qbChartOfAccountsId: String!) {
    getSpkCreditCardTeamMemberMapTbl(
      qbChartOfAccountsId: $qbChartOfAccountsId
    ) {
      qbChartOfAccountsId
      qbChartOfAccounts {
        qbChartOfAccountsId
        allSort
        qbChartOfAccountsName
        qbChartOfAccountsFullyQualifiedName
        qbChartOfAccountsActive
        cardLastFour
        createdAt
        updatedAt
        __typename
      }
      allSort
      teamMemberId
      teamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      isActive
      isDefault
      cardLastFour
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkCreditCardTeamMemberMapTbls = /* GraphQL */ `
  query ListSpkCreditCardTeamMemberMapTbls(
    $qbChartOfAccountsId: String
    $filter: ModelSpkCreditCardTeamMemberMapTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkCreditCardTeamMemberMapTbls(
      qbChartOfAccountsId: $qbChartOfAccountsId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        qbChartOfAccountsId
        allSort
        teamMemberId
        isActive
        isDefault
        cardLastFour
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkCreditCardChartOfAccountsTbl = /* GraphQL */ `
  query GetSpkCreditCardChartOfAccountsTbl($qbChartOfAccountsId: String!) {
    getSpkCreditCardChartOfAccountsTbl(
      qbChartOfAccountsId: $qbChartOfAccountsId
    ) {
      qbChartOfAccountsId
      allSort
      qbChartOfAccountsName
      qbChartOfAccountsFullyQualifiedName
      qbChartOfAccountsActive
      cardLastFour
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkCreditCardChartOfAccountsTbls = /* GraphQL */ `
  query ListSpkCreditCardChartOfAccountsTbls(
    $qbChartOfAccountsId: String
    $filter: ModelSpkCreditCardChartOfAccountsTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkCreditCardChartOfAccountsTbls(
      qbChartOfAccountsId: $qbChartOfAccountsId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        qbChartOfAccountsId
        allSort
        qbChartOfAccountsName
        qbChartOfAccountsFullyQualifiedName
        qbChartOfAccountsActive
        cardLastFour
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkStatementCategoryTbl = /* GraphQL */ `
  query GetSpkStatementCategoryTbl($id: ID!) {
    getSpkStatementCategoryTbl(id: $id) {
      id
      category
      code
      isVisible
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkStatementCategoryTbls = /* GraphQL */ `
  query ListSpkStatementCategoryTbls(
    $filter: ModelSpkStatementCategoryTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkStatementCategoryTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        category
        code
        isVisible
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTEquipmentBillableRateTypeTbl = /* GraphQL */ `
  query GetSpkDJTEquipmentBillableRateTypeTbl($id: ID!) {
    getSpkDJTEquipmentBillableRateTypeTbl(id: $id) {
      id
      billAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTEquipmentBillableRateTypeTbls = /* GraphQL */ `
  query ListSpkDJTEquipmentBillableRateTypeTbls(
    $filter: ModelSpkDJTEquipmentBillableRateTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTEquipmentBillableRateTypeTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPrimaryUnitTbl = /* GraphQL */ `
  query GetSpkPrimaryUnitTbl($id: ID!) {
    getSpkPrimaryUnitTbl(id: $id) {
      id
      allSort
      code
      codeSortable
      rates {
        unitCode
        unitId
        hourlyRate
        shiftRate
        dayRate
        createdAt
        updatedAt
        __typename
      }
      name
      year
      make
      model
      color
      irpiftaRegistered
      tag
      vin
      serial
      teamMemberId
      primaryDriver {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      isMarried
      marriageId
      unitFamily {
        id
        name
        isActive
        createdAt
        updatedAt
        __typename
      }
      purchDate
      purchAmt
      purchNotes
      soldDate
      soldAmt
      soldNotes
      isActive
      billRateDay
      billRateHour
      typeId
      type {
        id
        allSort
        name
        maintenanceName
        createdAt
        updatedAt
        __typename
      }
      subTypeId
      subType {
        id
        allSort
        typeId
        name
        maintenanceName
        priceCodeId
        qbExpenseCategoryId
        createdAt
        updatedAt
        __typename
      }
      seatAxle
      cgvw
      unladWt
      isDOTReg
      reqCDLDriver
      unitStatus {
        code
        allSort
        unitId
        statusId
        notes
        inService
        inServiceAlert
        divisionId
        lastInspected
        lastInspectedAt
        createdOn
        createdAt
        updatedAt
        __typename
      }
      unitSmallImageId
      unitSmallImage {
        id
        unitId
        createdById
        uploadedDateTime
        uploadedDocumentId
        unitDocumentTypeId
        unitIdUnitDocumentTypeId
        active
        isActive
        notes
        imageSetId
        createdAt
        updatedAt
        __typename
      }
      unitMediumImageId
      unitMediumImage {
        id
        unitId
        createdById
        uploadedDateTime
        uploadedDocumentId
        unitDocumentTypeId
        unitIdUnitDocumentTypeId
        active
        isActive
        notes
        imageSetId
        createdAt
        updatedAt
        __typename
      }
      unitDocuments {
        nextToken
        __typename
      }
      currentLocation
      isInOperation
      canTransfer
      isInspectedDaily
      requiresOperator
      requiresDriver
      auxillaryUnits {
        nextToken
        __typename
      }
      qbExpenseCategoryId
      qbExpenseCategoryNumber
      qbExpenseCategory
      iconId
      images {
        nextToken
        __typename
      }
      qrCodeValue {
        unitCode
        qrCodeValue
        createdAt
        updatedAt
        __typename
      }
      odometer
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPrimaryUnitTbls = /* GraphQL */ `
  query ListSpkPrimaryUnitTbls(
    $filter: ModelSpkPrimaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPrimaryUnitTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkIFTAFuelTaxTrackingTbl = /* GraphQL */ `
  query GetSpkIFTAFuelTaxTrackingTbl($id: ID!) {
    getSpkIFTAFuelTaxTrackingTbl(id: $id) {
      id
      allSort
      statementDate
      transactionId
      yearQuarter
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      teamMemberId
      teamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      stateTwoChar
      gallons
      odometer
      isApproved
      approvedById
      isActive
      approvedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkIFTAFuelTaxTrackingTbls = /* GraphQL */ `
  query ListSpkIFTAFuelTaxTrackingTbls(
    $filter: ModelSpkIFTAFuelTaxTrackingTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkIFTAFuelTaxTrackingTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        statementDate
        transactionId
        yearQuarter
        unitId
        teamMemberId
        stateTwoChar
        gallons
        odometer
        isApproved
        approvedById
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitQrMapTbl = /* GraphQL */ `
  query GetSpkUnitQrMapTbl($unitCode: String!) {
    getSpkUnitQrMapTbl(unitCode: $unitCode) {
      unitCode
      qrCodeValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitQrMapTbls = /* GraphQL */ `
  query ListSpkUnitQrMapTbls(
    $unitCode: String
    $filter: ModelSpkUnitQrMapTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkUnitQrMapTbls(
      unitCode: $unitCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        unitCode
        qrCodeValue
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitTypeTbl = /* GraphQL */ `
  query GetSpkUnitTypeTbl($id: ID!) {
    getSpkUnitTypeTbl(id: $id) {
      id
      allSort
      name
      maintenanceName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitTypeTbls = /* GraphQL */ `
  query ListSpkUnitTypeTbls(
    $filter: ModelSpkUnitTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkUnitTypeTbls(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        allSort
        name
        maintenanceName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitSubTypeTbl = /* GraphQL */ `
  query GetSpkUnitSubTypeTbl($id: ID!) {
    getSpkUnitSubTypeTbl(id: $id) {
      id
      allSort
      typeId
      type {
        id
        allSort
        name
        maintenanceName
        createdAt
        updatedAt
        __typename
      }
      name
      maintenanceName
      inspectionsPoints {
        nextToken
        __typename
      }
      priceCodeId
      priceCode {
        priceCode
        price
        year
        rateTypeId
        name
        divisionId
        divisionYear
        createdAt
        updatedAt
        __typename
      }
      qbExpenseCategoryId
      qbExpenseCategory {
        expenseCategory
        description
        QBId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitSubTypeTbls = /* GraphQL */ `
  query ListSpkUnitSubTypeTbls(
    $filter: ModelSpkUnitSubTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkUnitSubTypeTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        typeId
        name
        maintenanceName
        priceCodeId
        qbExpenseCategoryId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitPriceListTbl = /* GraphQL */ `
  query GetSpkUnitPriceListTbl($priceCodeDivision: String!) {
    getSpkUnitPriceListTbl(priceCodeDivision: $priceCodeDivision) {
      priceCodeDivision
      price
      year
      rateTypeId
      rateType {
        rateType
        description
        createdAt
        updatedAt
        __typename
      }
      name
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      divisionYear
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitPriceListTbls = /* GraphQL */ `
  query ListSpkUnitPriceListTbls(
    $priceCodeDivision: String
    $filter: ModelSpkUnitPriceListTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkUnitPriceListTbls(
      priceCodeDivision: $priceCodeDivision
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        priceCodeDivision
        price
        year
        rateTypeId
        name
        divisionId
        divisionYear
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitSubTypePriceCodeTbl = /* GraphQL */ `
  query GetSpkUnitSubTypePriceCodeTbl($priceCode: String!) {
    getSpkUnitSubTypePriceCodeTbl(priceCode: $priceCode) {
      priceCode
      price
      year
      rateTypeId
      rateType {
        rateType
        description
        createdAt
        updatedAt
        __typename
      }
      name
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      divisionYear
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitSubTypePriceCodeTbls = /* GraphQL */ `
  query ListSpkUnitSubTypePriceCodeTbls(
    $priceCode: String
    $filter: ModelSpkUnitSubTypePriceCodeTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkUnitSubTypePriceCodeTbls(
      priceCode: $priceCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        priceCode
        price
        year
        rateTypeId
        name
        divisionId
        divisionYear
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPlaidUserTbl = /* GraphQL */ `
  query GetSpkPlaidUserTbl($userId: ID!) {
    getSpkPlaidUserTbl(userId: $userId) {
      userId
      institutions {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPlaidUserTbls = /* GraphQL */ `
  query ListSpkPlaidUserTbls(
    $userId: ID
    $filter: ModelSpkPlaidUserTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkPlaidUserTbls(
      userId: $userId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPlaidInstitutionTbl = /* GraphQL */ `
  query GetSpkPlaidInstitutionTbl($id: ID!) {
    getSpkPlaidInstitutionTbl(id: $id) {
      id
      userId
      accessToken
      institutionId
      institution
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPlaidInstitutionTbls = /* GraphQL */ `
  query ListSpkPlaidInstitutionTbls(
    $filter: ModelSpkPlaidInstitutionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPlaidInstitutionTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        accessToken
        institutionId
        institution
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPlaidSyncTransactionCursorTbl = /* GraphQL */ `
  query GetSpkPlaidSyncTransactionCursorTbl($id: ID!) {
    getSpkPlaidSyncTransactionCursorTbl(id: $id) {
      id
      cursor
      lastUpdated
      previousUpdate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPlaidSyncTransactionCursorTbls = /* GraphQL */ `
  query ListSpkPlaidSyncTransactionCursorTbls(
    $filter: ModelSpkPlaidSyncTransactionCursorTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPlaidSyncTransactionCursorTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cursor
        lastUpdated
        previousUpdate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPlaidCreditCardTransactionTbl = /* GraphQL */ `
  query GetSpkPlaidCreditCardTransactionTbl($id: ID!) {
    getSpkPlaidCreditCardTransactionTbl(id: $id) {
      id
      capitalOneInstantNotificationId
      capitalOneInstantNotification {
        id
        allSort
        capitalOneCreditCardTransactionReceiptId
        plaidTransationId
        isMatched
        isSubmitted
        status
        lastFour
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        createdAt
        updatedAt
        __typename
      }
      capitalOneCreditCardTransactionReceiptId
      capitalOneCreditCardTransactionReceipt {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      accountNumber
      purchaseDate
      purchaseMerchant
      purchaseAmount
      purchaseInstitution
      accountId
      date
      amount
      merchantEntityId
      merchantEntityName
      store
      categoryId
      category
      location
      paymentChannel
      transactionId
      transactionType
      status
      approvedById
      approvedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      billingPeriod
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPlaidCreditCardTransactionTbls = /* GraphQL */ `
  query ListSpkPlaidCreditCardTransactionTbls(
    $filter: ModelSpkPlaidCreditCardTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPlaidCreditCardTransactionTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        capitalOneCreditCardTransactionReceiptId
        accountNumber
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        accountId
        date
        amount
        merchantEntityId
        merchantEntityName
        store
        categoryId
        category
        location
        paymentChannel
        transactionId
        transactionType
        status
        approvedById
        billingPeriod
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkCapitalOneInstantNotificationTbl = /* GraphQL */ `
  query GetSpkCapitalOneInstantNotificationTbl($id: ID!) {
    getSpkCapitalOneInstantNotificationTbl(id: $id) {
      id
      allSort
      capitalOneCreditCardTransactionReceiptId
      capitalOneCreditCardTransactionReceipt {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      plaidTransationId
      plaidTransaction {
        id
        capitalOneInstantNotificationId
        capitalOneCreditCardTransactionReceiptId
        accountNumber
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        accountId
        date
        amount
        merchantEntityId
        merchantEntityName
        store
        categoryId
        category
        location
        paymentChannel
        transactionId
        transactionType
        status
        approvedById
        billingPeriod
        createdAt
        updatedAt
        __typename
      }
      isMatched
      isSubmitted
      status
      lastFour
      purchaseDate
      purchaseMerchant
      purchaseAmount
      purchaseInstitution
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkCapitalOneInstantNotificationTbls = /* GraphQL */ `
  query ListSpkCapitalOneInstantNotificationTbls(
    $filter: ModelSpkCapitalOneInstantNotificationTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkCapitalOneInstantNotificationTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        capitalOneCreditCardTransactionReceiptId
        plaidTransationId
        isMatched
        isSubmitted
        status
        lastFour
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkCapitalOneCreditCardTransactionReceiptTbl = /* GraphQL */ `
  query GetSpkCapitalOneCreditCardTransactionReceiptTbl($id: ID!) {
    getSpkCapitalOneCreditCardTransactionReceiptTbl(id: $id) {
      id
      capitalOneInstantNotificationId
      capitalOneInstantNotification {
        id
        allSort
        capitalOneCreditCardTransactionReceiptId
        plaidTransationId
        isMatched
        isSubmitted
        status
        lastFour
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        createdAt
        updatedAt
        __typename
      }
      plaidCreditCardTransactionId
      plaidCreditCardTransaction {
        id
        capitalOneInstantNotificationId
        capitalOneCreditCardTransactionReceiptId
        accountNumber
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        accountId
        date
        amount
        merchantEntityId
        merchantEntityName
        store
        categoryId
        category
        location
        paymentChannel
        transactionId
        transactionType
        status
        approvedById
        billingPeriod
        createdAt
        updatedAt
        __typename
      }
      allSort
      matchStatus
      qbTransactionEntityId
      isReceiptUploaded
      uploadedDocuments {
        nextToken
        __typename
      }
      quickbooksExpenseId
      teamMemberId
      teamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      clientId
      client {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      expenseCategoryId
      expenseCategory {
        qbId
        allSort
        acctNum
        name
        appName
        isActive
        isVisible
        isIFTATracked
        isUnitRequired
        createdAt
        updatedAt
        __typename
      }
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      units {
        nextToken
        __typename
      }
      iftaFuelTaxTrackId
      iftaFuelTaxTrack {
        id
        allSort
        statementDate
        transactionId
        yearQuarter
        unitId
        teamMemberId
        stateTwoChar
        gallons
        odometer
        isApproved
        approvedById
        isActive
        createdAt
        updatedAt
        __typename
      }
      addedNotes
      hasIssue
      issue
      transactionType
      amount
      invoiceReceiptDate
      invoiceReceiptID
      statementTotal
      amountDue
      orderDate
      amountPaid
      gratuity
      vendorName
      dueDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkCapitalOneCreditCardTransactionReceiptTbls = /* GraphQL */ `
  query ListSpkCapitalOneCreditCardTransactionReceiptTbls(
    $filter: ModelSpkCapitalOneCreditCardTransactionReceiptTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkCapitalOneCreditCardTransactionReceiptTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkCapitalOneTransactionReceiptDocumentLinkTbl = /* GraphQL */ `
  query GetSpkCapitalOneTransactionReceiptDocumentLinkTbl($id: ID!) {
    getSpkCapitalOneTransactionReceiptDocumentLinkTbl(id: $id) {
      id
      receiptId
      receipt {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      uploadedDocumentId
      uploadedDocument {
        id
        identityId
        key
        bucket
        owner
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkCapitalOneTransactionReceiptDocumentLinkTbls = /* GraphQL */ `
  query ListSpkCapitalOneTransactionReceiptDocumentLinkTbls(
    $filter: ModelSpkCapitalOneTransactionReceiptDocumentLinkTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkCapitalOneTransactionReceiptDocumentLinkTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        receiptId
        uploadedDocumentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPlaidTransactionTbl = /* GraphQL */ `
  query GetSpkPlaidTransactionTbl($id: ID!) {
    getSpkPlaidTransactionTbl(id: $id) {
      id
      institution_id
      account_id
      account_owner
      amount
      authorized_date
      category
      date
      location
      merchant_entity_id
      name
      merchant_name
      payment_channel
      pending
      pending_transaction_id
      pending_transaction
      transaction_code
      transaction_id
      transaction_type
      cursorId
      cursor {
        id
        cursor
        lastUpdated
        previousUpdate
        createdAt
        updatedAt
        __typename
      }
      matched
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPlaidTransactionTbls = /* GraphQL */ `
  query ListSpkPlaidTransactionTbls(
    $filter: ModelSpkPlaidTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPlaidTransactionTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        institution_id
        account_id
        account_owner
        amount
        authorized_date
        category
        date
        location
        merchant_entity_id
        name
        merchant_name
        payment_channel
        pending
        pending_transaction_id
        pending_transaction
        transaction_code
        transaction_id
        transaction_type
        cursorId
        matched
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPlaidPendingTransactionTbl = /* GraphQL */ `
  query GetSpkPlaidPendingTransactionTbl($id: ID!) {
    getSpkPlaidPendingTransactionTbl(id: $id) {
      id
      cardNumber
      date
      merchant
      transactionType
      amount
      pendingSort
      postedTransactionId
      postedTransaction {
        id
        institution_id
        account_id
        account_owner
        amount
        authorized_date
        category
        date
        location
        merchant_entity_id
        name
        merchant_name
        payment_channel
        pending
        pending_transaction_id
        pending_transaction
        transaction_code
        transaction_id
        transaction_type
        cursorId
        matched
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPlaidPendingTransactionTbls = /* GraphQL */ `
  query ListSpkPlaidPendingTransactionTbls(
    $filter: ModelSpkPlaidPendingTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPlaidPendingTransactionTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cardNumber
        date
        merchant
        transactionType
        amount
        pendingSort
        postedTransactionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPriceCodeRateTypeTbl = /* GraphQL */ `
  query GetSpkPriceCodeRateTypeTbl($rateType: String!) {
    getSpkPriceCodeRateTypeTbl(rateType: $rateType) {
      rateType
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPriceCodeRateTypeTbls = /* GraphQL */ `
  query ListSpkPriceCodeRateTypeTbls(
    $rateType: String
    $filter: ModelSpkPriceCodeRateTypeTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkPriceCodeRateTypeTbls(
      rateType: $rateType
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        rateType
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkQBExpenseCategoryTbl = /* GraphQL */ `
  query GetSpkQBExpenseCategoryTbl($qbId: String!) {
    getSpkQBExpenseCategoryTbl(qbId: $qbId) {
      qbId
      allSort
      acctNum
      name
      appName
      isActive
      isVisible
      isIFTATracked
      isUnitRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkQBExpenseCategoryTbls = /* GraphQL */ `
  query ListSpkQBExpenseCategoryTbls(
    $qbId: String
    $filter: ModelSpkQBExpenseCategoryTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkQBExpenseCategoryTbls(
      qbId: $qbId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        qbId
        allSort
        acctNum
        name
        appName
        isActive
        isVisible
        isIFTATracked
        isUnitRequired
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitSubTypeQBExpenseCategoryTbl = /* GraphQL */ `
  query GetSpkUnitSubTypeQBExpenseCategoryTbl($expenseCategory: String!) {
    getSpkUnitSubTypeQBExpenseCategoryTbl(expenseCategory: $expenseCategory) {
      expenseCategory
      description
      QBId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitSubTypeQBExpenseCategoryTbls = /* GraphQL */ `
  query ListSpkUnitSubTypeQBExpenseCategoryTbls(
    $expenseCategory: String
    $filter: ModelSpkUnitSubTypeQBExpenseCategoryTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkUnitSubTypeQBExpenseCategoryTbls(
      expenseCategory: $expenseCategory
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        expenseCategory
        description
        QBId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitInspectionPointTbl = /* GraphQL */ `
  query GetSpkUnitInspectionPointTbl($id: ID!) {
    getSpkUnitInspectionPointTbl(id: $id) {
      id
      order
      topic
      point
      subTypes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitInspectionPointTbls = /* GraphQL */ `
  query ListSpkUnitInspectionPointTbls(
    $filter: ModelSpkUnitInspectionPointTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkUnitInspectionPointTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order
        topic
        point
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkContactTbl = /* GraphQL */ `
  query GetSpkContactTbl($id: ID!) {
    getSpkContactTbl(id: $id) {
      id
      isMachineGenerated
      contactTypeId
      contactType {
        id
        name
        isActive
        createdAt
        updatedAt
        __typename
      }
      firstName
      middleName
      lastName
      companyName
      phone
      address
      email
      url
      notes
      isActive
      isDisplayed
      searchTags
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkContactTbls = /* GraphQL */ `
  query ListSpkContactTbls(
    $filter: ModelSpkContactTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkContactTbls(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        isMachineGenerated
        contactTypeId
        firstName
        middleName
        lastName
        companyName
        phone
        address
        email
        url
        notes
        isActive
        isDisplayed
        searchTags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkContactSubTypeTbl = /* GraphQL */ `
  query GetSpkContactSubTypeTbl($id: ID!) {
    getSpkContactSubTypeTbl(id: $id) {
      id
      type
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkContactSubTypeTbls = /* GraphQL */ `
  query ListSpkContactSubTypeTbls(
    $filter: ModelSpkContactSubTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkContactSubTypeTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        value
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkContactTypeTbl = /* GraphQL */ `
  query GetSpkContactTypeTbl($id: ID!) {
    getSpkContactTypeTbl(id: $id) {
      id
      name
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkContactTypeTbls = /* GraphQL */ `
  query ListSpkContactTypeTbls(
    $filter: ModelSpkContactTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkContactTypeTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitMarriageTbl = /* GraphQL */ `
  query GetSpkUnitMarriageTbl($id: ID!) {
    getSpkUnitMarriageTbl(id: $id) {
      id
      name
      units {
        nextToken
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitMarriageTbls = /* GraphQL */ `
  query ListSpkUnitMarriageTbls(
    $filter: ModelSpkUnitMarriageTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkUnitMarriageTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTPrimaryUnitBillableRateTbl = /* GraphQL */ `
  query GetSpkDJTPrimaryUnitBillableRateTbl($unitCode: String!) {
    getSpkDJTPrimaryUnitBillableRateTbl(unitCode: $unitCode) {
      unitCode
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      hourlyRate
      shiftRate
      dayRate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTPrimaryUnitBillableRateTbls = /* GraphQL */ `
  query ListSpkDJTPrimaryUnitBillableRateTbls(
    $unitCode: String
    $filter: ModelSpkDJTPrimaryUnitBillableRateTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkDJTPrimaryUnitBillableRateTbls(
      unitCode: $unitCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        unitCode
        unitId
        hourlyRate
        shiftRate
        dayRate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTClientTbl = /* GraphQL */ `
  query GetSpkDJTClientTbl($id: ID!) {
    getSpkDJTClientTbl(id: $id) {
      id
      allSort
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      contactCompany
      clientURL
      clientBillingEmail
      contactName
      contactEmail
      contactPhone
      contacts {
        nextToken
        __typename
      }
      isActive
      isSyncedToQB
      qbId
      qbClassName
      qbClassId
      qbSandboxClassName
      qbSandboxClassId
      qbSandboxId
      qbDisplayName
      qbCustomer
      qbCompany
      qbStreetAddress
      qbCity
      qbState
      qbCountry
      qbZip
      qbPhone
      qbEmail
      qbCustomerType
      staleAfterDate
      verifiedEmailDomains {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTClientTbls = /* GraphQL */ `
  query ListSpkDJTClientTbls(
    $filter: ModelSpkDJTClientTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTClientTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTClientVerifiedEmailDomainTbl = /* GraphQL */ `
  query GetSpkDJTClientVerifiedEmailDomainTbl($id: ID!) {
    getSpkDJTClientVerifiedEmailDomainTbl(id: $id) {
      id
      clientId
      client {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      domain
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTClientVerifiedEmailDomainTbls = /* GraphQL */ `
  query ListSpkDJTClientVerifiedEmailDomainTbls(
    $filter: ModelSpkDJTClientVerifiedEmailDomainTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTClientVerifiedEmailDomainTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        domain
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTClientContactTbl = /* GraphQL */ `
  query GetSpkDJTClientContactTbl($id: ID!) {
    getSpkDJTClientContactTbl(id: $id) {
      id
      clientId
      client {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      name
      email
      emailVerified
      phone
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTClientContactTbls = /* GraphQL */ `
  query ListSpkDJTClientContactTbls(
    $filter: ModelSpkDJTClientContactTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTClientContactTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        name
        email
        emailVerified
        phone
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTPOTbl = /* GraphQL */ `
  query GetSpkDJTPOTbl($id: ID!) {
    getSpkDJTPOTbl(id: $id) {
      id
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      djtClientId
      djtClient {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      po
      poDivisionClient
      poLocation
      divisionClientPOHash
      poDescription
      poNotes
      isClosed
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTPOTbls = /* GraphQL */ `
  query ListSpkDJTPOTbls(
    $filter: ModelSpkDJTPOTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTPOTbls(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        divisionId
        djtClientId
        po
        poDivisionClient
        poLocation
        divisionClientPOHash
        poDescription
        poNotes
        isClosed
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTCurrentStatus = /* GraphQL */ `
  query GetSpkDJTCurrentStatus($id: ID!) {
    getSpkDJTCurrentStatus(id: $id) {
      id
      allSort
      order
      status
      statusCode
      statusGroup
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTCurrentStatuses = /* GraphQL */ `
  query ListSpkDJTCurrentStatuses(
    $filter: ModelSpkDJTCurrentStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTCurrentStatuses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        order
        status
        statusCode
        statusGroup
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkClientContractTbl = /* GraphQL */ `
  query GetSpkClientContractTbl($id: ID!) {
    getSpkClientContractTbl(id: $id) {
      id
      name
      createDateTime
      clientId
      client {
        id
        isMachineGenerated
        contactTypeId
        firstName
        middleName
        lastName
        companyName
        phone
        address
        email
        url
        notes
        isActive
        isDisplayed
        searchTags
        createdAt
        updatedAt
        __typename
      }
      documentId
      document {
        id
        identityId
        key
        bucket
        owner
        createdAt
        updatedAt
        __typename
      }
      createdById
      createdBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkClientContractTbls = /* GraphQL */ `
  query ListSpkClientContractTbls(
    $filter: ModelSpkClientContractTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkClientContractTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createDateTime
        clientId
        documentId
        createdById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTCurrentStatusJournal = /* GraphQL */ `
  query GetSpkDJTCurrentStatusJournal($id: ID!) {
    getSpkDJTCurrentStatusJournal(id: $id) {
      id
      djtId
      djt {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      createdDateTime
      createdBy
      creator {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      statusId
      status {
        id
        allSort
        order
        status
        statusCode
        statusGroup
        createdAt
        updatedAt
        __typename
      }
      note
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTCurrentStatusJournals = /* GraphQL */ `
  query ListSpkDJTCurrentStatusJournals(
    $filter: ModelSpkDJTCurrentStatusJournalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTCurrentStatusJournals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        createdDateTime
        createdBy
        statusId
        note
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTLaborTbl = /* GraphQL */ `
  query GetSpkDJTLaborTbl($id: ID!) {
    getSpkDJTLaborTbl(id: $id) {
      id
      djtId
      djt {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      isActive
      date
      teamMemberId
      teamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      customLaborName
      jobClassId
      jobClass {
        divisionPosition
        className
        appDisplayName
        invoiceDisplayName
        unionDisplayName
        hourlyRate
        overtimeRate
        divisionId
        isActive
        isHiddenByDefault
        createdAt
        updatedAt
        __typename
      }
      startTime
      finishTime
      perDiemAmount
      lunchDuration
      straightTime
      overTime
      departmentEmployee
      totalPrice
      statusId
      status {
        id
        allSort
        order
        status
        statusCode
        statusGroup
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTLaborTbls = /* GraphQL */ `
  query ListSpkDJTLaborTbls(
    $filter: ModelSpkDJTLaborTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTLaborTbls(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        djtId
        isActive
        date
        teamMemberId
        customLaborName
        jobClassId
        startTime
        finishTime
        perDiemAmount
        lunchDuration
        straightTime
        overTime
        departmentEmployee
        totalPrice
        statusId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTClientSummaryEmailSent = /* GraphQL */ `
  query GetSpkDJTClientSummaryEmailSent($id: ID!) {
    getSpkDJTClientSummaryEmailSent(id: $id) {
      id
      teamMemberId
      teamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      supervisorName
      supervisorEmail
      sentToEmail
      sentToCC
      sentToName
      sentToClient
      djtId
      djt {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      dateSent
      djtDate
      djtDescription
      djtPO
      message
      summaryType
      laborCost
      equipmentCost
      materialCost
      totalCost
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTClientSummaryEmailSents = /* GraphQL */ `
  query ListSpkDJTClientSummaryEmailSents(
    $filter: ModelSpkDJTClientSummaryEmailSentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTClientSummaryEmailSents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teamMemberId
        supervisorName
        supervisorEmail
        sentToEmail
        sentToCC
        sentToName
        sentToClient
        djtId
        dateSent
        djtDate
        djtDescription
        djtPO
        message
        summaryType
        laborCost
        equipmentCost
        materialCost
        totalCost
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTClientSummaryEmailCCEmail = /* GraphQL */ `
  query GetSpkDJTClientSummaryEmailCCEmail($id: ID!) {
    getSpkDJTClientSummaryEmailCCEmail(id: $id) {
      id
      email
      clientId
      client {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      addedById
      addedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      isVerified
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTClientSummaryEmailCCEmails = /* GraphQL */ `
  query ListSpkDJTClientSummaryEmailCCEmails(
    $filter: ModelSpkDJTClientSummaryEmailCCEmailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTClientSummaryEmailCCEmails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        clientId
        addedById
        isVerified
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTJobClassBillableRateTbl = /* GraphQL */ `
  query GetSpkDJTJobClassBillableRateTbl($divisionClassNameHash: String!) {
    getSpkDJTJobClassBillableRateTbl(
      divisionClassNameHash: $divisionClassNameHash
    ) {
      divisionClassNameHash
      className
      classDescription
      hourlyRate
      shiftRate
      overtimeRate
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTJobClassBillableRateTbls = /* GraphQL */ `
  query ListSpkDJTJobClassBillableRateTbls(
    $divisionClassNameHash: String
    $filter: ModelSpkDJTJobClassBillableRateTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkDJTJobClassBillableRateTbls(
      divisionClassNameHash: $divisionClassNameHash
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        divisionClassNameHash
        className
        classDescription
        hourlyRate
        shiftRate
        overtimeRate
        divisionId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkDJTMaterialTbl = /* GraphQL */ `
  query GetSpkDJTMaterialTbl($id: ID!) {
    getSpkDJTMaterialTbl(id: $id) {
      id
      djtId
      djt {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      isActive
      date
      description
      price
      quantity
      totalPrice
      hasReceipt
      includeReceipt
      isCustom
      isDefault
      statusId
      status {
        id
        allSort
        order
        status
        statusCode
        statusGroup
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkDJTMaterialTbls = /* GraphQL */ `
  query ListSpkDJTMaterialTbls(
    $filter: ModelSpkDJTMaterialTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkDJTMaterialTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        isActive
        date
        description
        price
        quantity
        totalPrice
        hasReceipt
        includeReceipt
        isCustom
        isDefault
        statusId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitImageTbl = /* GraphQL */ `
  query GetSpkUnitImageTbl($id: ID!) {
    getSpkUnitImageTbl(id: $id) {
      id
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      imageDescription
      createdDateTime
      createdById
      createdBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      uploadedDocumentId
      uploadedDocument {
        id
        identityId
        key
        bucket
        owner
        createdAt
        updatedAt
        __typename
      }
      unitDocumentTypeId
      unitDocumentType {
        id
        allSort
        name
        group
        isActive
        createdAt
        updatedAt
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitImageTbls = /* GraphQL */ `
  query ListSpkUnitImageTbls(
    $filter: ModelSpkUnitImageTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkUnitImageTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        imageDescription
        createdDateTime
        createdById
        uploadedDocumentId
        unitDocumentTypeId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPrimaryUnitInspectionQueueTbl = /* GraphQL */ `
  query GetSpkPrimaryUnitInspectionQueueTbl($id: ID!) {
    getSpkPrimaryUnitInspectionQueueTbl(id: $id) {
      id
      allSort
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      active
      code
      unitStatus {
        code
        allSort
        unitId
        statusId
        notes
        inService
        inServiceAlert
        divisionId
        lastInspected
        lastInspectedAt
        createdOn
        createdAt
        updatedAt
        __typename
      }
      createdById
      createdBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      claimedById
      claimedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      createdOn
      claimedOn
      completedOn
      inspectedDateTime
      inspectedById
      inspectedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      inspectionId
      inspection {
        id
        divisionDateForFailure
        divisionDate
        unitId
        inspectedOn
        inspectedAt
        inspectedById
        createdById
        divisionId
        dateUnit
        statusId
        failureCount
        timeToInspect
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPrimaryUnitInspectionQueueTbls = /* GraphQL */ `
  query ListSpkPrimaryUnitInspectionQueueTbls(
    $filter: ModelSpkPrimaryUnitInspectionQueueTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPrimaryUnitInspectionQueueTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        divisionId
        unitId
        active
        code
        createdById
        claimedById
        createdOn
        claimedOn
        completedOn
        inspectedDateTime
        inspectedById
        inspectionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPrimaryUnitInspectionTbl = /* GraphQL */ `
  query GetSpkPrimaryUnitInspectionTbl($id: ID!) {
    getSpkPrimaryUnitInspectionTbl(id: $id) {
      id
      divisionDateForFailure
      divisionDate
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      inspectedOn
      inspectedAt
      inspectedById
      inspectedBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      createdById
      createdBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      dateUnit
      statusId
      status {
        id
        allSort
        status
        adminOnly
        isAvailable
        doAlert
        alert
        order
        statusQuery
        createdAt
        updatedAt
        __typename
      }
      failureCount
      completedInspection {
        nextToken
        __typename
      }
      timeToInspect
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPrimaryUnitInspectionTbls = /* GraphQL */ `
  query ListSpkPrimaryUnitInspectionTbls(
    $filter: ModelSpkPrimaryUnitInspectionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPrimaryUnitInspectionTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        divisionDateForFailure
        divisionDate
        unitId
        inspectedOn
        inspectedAt
        inspectedById
        createdById
        divisionId
        dateUnit
        statusId
        failureCount
        timeToInspect
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPrimaryUnitCompletedInspectionTbl = /* GraphQL */ `
  query GetSpkPrimaryUnitCompletedInspectionTbl($id: ID!) {
    getSpkPrimaryUnitCompletedInspectionTbl(id: $id) {
      id
      unitInspectionId
      unitInspection {
        id
        divisionDateForFailure
        divisionDate
        unitId
        inspectedOn
        inspectedAt
        inspectedById
        createdById
        divisionId
        dateUnit
        statusId
        failureCount
        timeToInspect
        createdAt
        updatedAt
        __typename
      }
      inspectionPointId
      inspectionPoint {
        id
        order
        topic
        point
        createdAt
        updatedAt
        __typename
      }
      didPass
      failedReason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPrimaryUnitCompletedInspectionTbls = /* GraphQL */ `
  query ListSpkPrimaryUnitCompletedInspectionTbls(
    $filter: ModelSpkPrimaryUnitCompletedInspectionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPrimaryUnitCompletedInspectionTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitInspectionId
        inspectionPointId
        didPass
        failedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitDocumentTbl = /* GraphQL */ `
  query GetSpkUnitDocumentTbl($id: ID!) {
    getSpkUnitDocumentTbl(id: $id) {
      id
      unitId
      createdById
      createdBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      uploadedDateTime
      uploadedDocumentId
      uploadedDocument {
        id
        identityId
        key
        bucket
        owner
        createdAt
        updatedAt
        __typename
      }
      unitDocumentTypeId
      unitDocumentType {
        id
        allSort
        name
        group
        isActive
        createdAt
        updatedAt
        __typename
      }
      unitIdUnitDocumentTypeId
      active
      isActive
      notes
      imageSetId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitDocumentTbls = /* GraphQL */ `
  query ListSpkUnitDocumentTbls(
    $filter: ModelSpkUnitDocumentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkUnitDocumentTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        createdById
        uploadedDateTime
        uploadedDocumentId
        unitDocumentTypeId
        unitIdUnitDocumentTypeId
        active
        isActive
        notes
        imageSetId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitDocumentTypeTbl = /* GraphQL */ `
  query GetSpkUnitDocumentTypeTbl($id: ID!) {
    getSpkUnitDocumentTypeTbl(id: $id) {
      id
      allSort
      name
      group
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitDocumentTypeTbls = /* GraphQL */ `
  query ListSpkUnitDocumentTypeTbls(
    $filter: ModelSpkUnitDocumentTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkUnitDocumentTypeTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        group
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPrimaryUnitStatusTbl = /* GraphQL */ `
  query GetSpkPrimaryUnitStatusTbl($code: String!) {
    getSpkPrimaryUnitStatusTbl(code: $code) {
      code
      allSort
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      statusId
      status {
        id
        allSort
        status
        adminOnly
        isAvailable
        doAlert
        alert
        order
        statusQuery
        createdAt
        updatedAt
        __typename
      }
      notes
      inService
      inServiceAlert
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      lastInspected
      lastInspectedAt
      inspectionQueue {
        nextToken
        __typename
      }
      inspections {
        nextToken
        __typename
      }
      createdOn
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPrimaryUnitStatusTbls = /* GraphQL */ `
  query ListSpkPrimaryUnitStatusTbls(
    $code: String
    $filter: ModelSpkPrimaryUnitStatusTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkPrimaryUnitStatusTbls(
      code: $code
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        code
        allSort
        unitId
        statusId
        notes
        inService
        inServiceAlert
        divisionId
        lastInspected
        lastInspectedAt
        createdOn
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkUnitHistoryTbl = /* GraphQL */ `
  query GetSpkUnitHistoryTbl($id: ID!) {
    getSpkUnitHistoryTbl(id: $id) {
      id
      unitId
      unit {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      statusId
      status {
        id
        allSort
        status
        adminOnly
        isAvailable
        doAlert
        alert
        order
        statusQuery
        createdAt
        updatedAt
        __typename
      }
      notes
      inService
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      createdOn
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkUnitHistoryTbls = /* GraphQL */ `
  query ListSpkUnitHistoryTbls(
    $filter: ModelSpkUnitHistoryTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkUnitHistoryTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        statusId
        notes
        inService
        divisionId
        createdOn
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPrimaryUnitStatusOptionTbl = /* GraphQL */ `
  query GetSpkPrimaryUnitStatusOptionTbl($id: ID!) {
    getSpkPrimaryUnitStatusOptionTbl(id: $id) {
      id
      allSort
      status
      adminOnly
      isAvailable
      doAlert
      alert
      order
      statusQuery
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPrimaryUnitStatusOptionTbls = /* GraphQL */ `
  query ListSpkPrimaryUnitStatusOptionTbls(
    $filter: ModelSpkPrimaryUnitStatusOptionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPrimaryUnitStatusOptionTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        status
        adminOnly
        isAvailable
        doAlert
        alert
        order
        statusQuery
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkNavMenuTbl = /* GraphQL */ `
  query GetSpkNavMenuTbl($id: ID!) {
    getSpkNavMenuTbl(id: $id) {
      id
      allSort
      menuItem
      menuClass
      linkTo
      menuAltText
      displayOrder
      isPhoneSafe
      groups {
        nextToken
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkNavMenuTbls = /* GraphQL */ `
  query ListSpkNavMenuTbls(
    $filter: ModelSpkNavMenuTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkNavMenuTbls(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        allSort
        menuItem
        menuClass
        linkTo
        menuAltText
        displayOrder
        isPhoneSafe
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkNavMenuUserTbl = /* GraphQL */ `
  query GetSpkNavMenuUserTbl($id: ID!) {
    getSpkNavMenuUserTbl(id: $id) {
      id
      tmId
      teamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      navMenuId
      navMenu {
        id
        allSort
        menuItem
        menuClass
        linkTo
        menuAltText
        displayOrder
        isPhoneSafe
        isActive
        createdAt
        updatedAt
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkNavMenuUserTbls = /* GraphQL */ `
  query ListSpkNavMenuUserTbls(
    $filter: ModelSpkNavMenuUserTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkNavMenuUserTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tmId
        navMenuId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkNavCognitoGroupTbl = /* GraphQL */ `
  query GetSpkNavCognitoGroupTbl($id: ID!) {
    getSpkNavCognitoGroupTbl(id: $id) {
      id
      allSort
      cognitoGroupId
      cognitoGroup {
        id
        allSort
        name
        description
        createdAt
        updatedAt
        __typename
      }
      menuItemId
      menuItem {
        id
        allSort
        menuItem
        menuClass
        linkTo
        menuAltText
        displayOrder
        isPhoneSafe
        isActive
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkNavCognitoGroupTbls = /* GraphQL */ `
  query ListSpkNavCognitoGroupTbls(
    $filter: ModelSpkNavCognitoGroupTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkNavCognitoGroupTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        cognitoGroupId
        menuItemId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkCognitoGroupTbl = /* GraphQL */ `
  query GetSpkCognitoGroupTbl($id: ID!) {
    getSpkCognitoGroupTbl(id: $id) {
      id
      allSort
      name
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkCognitoGroupTbls = /* GraphQL */ `
  query ListSpkCognitoGroupTbls(
    $filter: ModelSpkCognitoGroupTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkCognitoGroupTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPubSubMessageAcknowledgedTbl = /* GraphQL */ `
  query GetSpkPubSubMessageAcknowledgedTbl($id: ID!) {
    getSpkPubSubMessageAcknowledgedTbl(id: $id) {
      id
      byTeamMemberId
      ByTeamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      messageId
      message {
        id
        subject
        message
        messageJSON
        fromId
        sentAt
        topicId
        publisherId
        publisherType
        statusId
        createdAt
        updatedAt
        __typename
      }
      markReceived
      markRead
      markDeleted
      markSaved
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPubSubMessageAcknowledgedTbls = /* GraphQL */ `
  query ListSpkPubSubMessageAcknowledgedTbls(
    $filter: ModelSpkPubSubMessageAcknowledgedTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPubSubMessageAcknowledgedTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        byTeamMemberId
        messageId
        markReceived
        markRead
        markDeleted
        markSaved
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPubSubMessageStatusTbl = /* GraphQL */ `
  query GetSpkPubSubMessageStatusTbl($id: ID!) {
    getSpkPubSubMessageStatusTbl(id: $id) {
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPubSubMessageStatusTbls = /* GraphQL */ `
  query ListSpkPubSubMessageStatusTbls(
    $filter: ModelSpkPubSubMessageStatusTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPubSubMessageStatusTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPubSubMessageTbl = /* GraphQL */ `
  query GetSpkPubSubMessageTbl($id: ID!) {
    getSpkPubSubMessageTbl(id: $id) {
      id
      subject
      message
      messageJSON
      fromId
      from {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      sentAt
      topicId
      topic {
        id
        name
        nameCode
        categoryId
        subscribeGroups
        publishGroups
        createdById
        isActive
        createdAt
        updatedAt
        __typename
      }
      publisherId
      publisherType
      statusId
      status {
        id
        status
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPubSubMessageTbls = /* GraphQL */ `
  query ListSpkPubSubMessageTbls(
    $filter: ModelSpkPubSubMessageTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPubSubMessageTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subject
        message
        messageJSON
        fromId
        sentAt
        topicId
        publisherId
        publisherType
        statusId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPubSubTopicTbl = /* GraphQL */ `
  query GetSpkPubSubTopicTbl($id: ID!) {
    getSpkPubSubTopicTbl(id: $id) {
      id
      name
      nameCode
      categoryId
      category {
        id
        name
        desc
        code
        createdAt
        updatedAt
        __typename
      }
      subscribeGroups
      publishGroups
      createdById
      createdBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPubSubTopicTbls = /* GraphQL */ `
  query ListSpkPubSubTopicTbls(
    $filter: ModelSpkPubSubTopicTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPubSubTopicTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        nameCode
        categoryId
        subscribeGroups
        publishGroups
        createdById
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPubSubTopicCategoryTbl = /* GraphQL */ `
  query GetSpkPubSubTopicCategoryTbl($id: ID!) {
    getSpkPubSubTopicCategoryTbl(id: $id) {
      id
      name
      desc
      code
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPubSubTopicCategoryTbls = /* GraphQL */ `
  query ListSpkPubSubTopicCategoryTbls(
    $filter: ModelSpkPubSubTopicCategoryTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPubSubTopicCategoryTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        desc
        code
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPubSubPublisherTbl = /* GraphQL */ `
  query GetSpkPubSubPublisherTbl($id: ID!) {
    getSpkPubSubPublisherTbl(id: $id) {
      id
      publisherName
      publisherId
      publisherType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPubSubPublisherTbls = /* GraphQL */ `
  query ListSpkPubSubPublisherTbls(
    $filter: ModelSpkPubSubPublisherTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPubSubPublisherTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        publisherName
        publisherId
        publisherType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkPubSubSubscriberTbl = /* GraphQL */ `
  query GetSpkPubSubSubscriberTbl($id: ID!) {
    getSpkPubSubSubscriberTbl(id: $id) {
      id
      teamMemberId
      teamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      topicId
      topic {
        id
        name
        nameCode
        categoryId
        subscribeGroups
        publishGroups
        createdById
        isActive
        createdAt
        updatedAt
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkPubSubSubscriberTbls = /* GraphQL */ `
  query ListSpkPubSubSubscriberTbls(
    $filter: ModelSpkPubSubSubscriberTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkPubSubSubscriberTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teamMemberId
        topicId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkISolvedHoursTbl = /* GraphQL */ `
  query GetSpkISolvedHoursTbl($id: ID!) {
    getSpkISolvedHoursTbl(id: $id) {
      id
      employeeNumber
      teamMember {
        employeeNumber
        allSort
        employeeName
        departmentId
        teamMemberId
        isActive
        createdAt
        updatedAt
        __typename
      }
      employeeName
      workDay
      totalHours
      departmentId
      department {
        id
        allSort
        departmentCode
        departmentName
        divisionId
        workLocation
        isPrimary
        divisionOrder
        createdAt
        updatedAt
        __typename
      }
      departmentIdWorkDay
      departmentEmployeeNumber
      popularity {
        departmentEmployeeNumber
        department
        employeeNumber
        popularity
        createdAt
        updatedAt
        __typename
      }
      hours
      punchIn
      punchOut
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkISolvedHoursTbls = /* GraphQL */ `
  query ListSpkISolvedHoursTbls(
    $filter: ModelSpkISolvedHoursTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkISolvedHoursTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeNumber
        employeeName
        workDay
        totalHours
        departmentId
        departmentIdWorkDay
        departmentEmployeeNumber
        hours
        punchIn
        punchOut
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkISolvedMapEmpNoToTeamMemberTbl = /* GraphQL */ `
  query GetSpkISolvedMapEmpNoToTeamMemberTbl($employeeNumber: String!) {
    getSpkISolvedMapEmpNoToTeamMemberTbl(employeeNumber: $employeeNumber) {
      employeeNumber
      allSort
      employeeName
      employeeTime {
        nextToken
        __typename
      }
      departmentId
      department {
        id
        allSort
        departmentCode
        departmentName
        divisionId
        workLocation
        isPrimary
        divisionOrder
        createdAt
        updatedAt
        __typename
      }
      teamMemberId
      teamMember {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkISolvedMapEmpNoToTeamMemberTbls = /* GraphQL */ `
  query ListSpkISolvedMapEmpNoToTeamMemberTbls(
    $employeeNumber: String
    $filter: ModelSpkISolvedMapEmpNoToTeamMemberTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkISolvedMapEmpNoToTeamMemberTbls(
      employeeNumber: $employeeNumber
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        employeeNumber
        allSort
        employeeName
        departmentId
        teamMemberId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkISolvedMapDepartToDivTbl = /* GraphQL */ `
  query GetSpkISolvedMapDepartToDivTbl($id: ID!) {
    getSpkISolvedMapDepartToDivTbl(id: $id) {
      id
      allSort
      departmentCode
      departmentName
      divisionId
      division {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      workLocation
      isPrimary
      divisionOrder
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkISolvedMapDepartToDivTbls = /* GraphQL */ `
  query ListSpkISolvedMapDepartToDivTbls(
    $filter: ModelSpkISolvedMapDepartToDivTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkISolvedMapDepartToDivTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        departmentCode
        departmentName
        divisionId
        workLocation
        isPrimary
        divisionOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkISolvedDailyDepartmentPunchesTbl = /* GraphQL */ `
  query GetSpkISolvedDailyDepartmentPunchesTbl(
    $dateDepartmentEmployeeTime: String!
  ) {
    getSpkISolvedDailyDepartmentPunchesTbl(
      dateDepartmentEmployeeTime: $dateDepartmentEmployeeTime
    ) {
      dateDepartmentEmployeeTime
      punchDate
      punchTime
      departmentId
      department {
        id
        allSort
        departmentCode
        departmentName
        divisionId
        workLocation
        isPrimary
        divisionOrder
        createdAt
        updatedAt
        __typename
      }
      dateDepartment
      iSolvedDatePunched
      iSolvedDepartmentName
      iSolvedEmployeeNumber
      teamMember {
        employeeNumber
        allSort
        employeeName
        departmentId
        teamMemberId
        isActive
        createdAt
        updatedAt
        __typename
      }
      departmentEmployee
      popularity {
        departmentEmployeeNumber
        department
        employeeNumber
        popularity
        createdAt
        updatedAt
        __typename
      }
      punchMode
      punchDateClassification
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkISolvedDailyDepartmentPunchesTbls = /* GraphQL */ `
  query ListSpkISolvedDailyDepartmentPunchesTbls(
    $dateDepartmentEmployeeTime: String
    $filter: ModelSpkISolvedDailyDepartmentPunchesTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkISolvedDailyDepartmentPunchesTbls(
      dateDepartmentEmployeeTime: $dateDepartmentEmployeeTime
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        dateDepartmentEmployeeTime
        punchDate
        punchTime
        departmentId
        dateDepartment
        iSolvedDatePunched
        iSolvedDepartmentName
        iSolvedEmployeeNumber
        departmentEmployee
        punchMode
        punchDateClassification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const getSpkISolvedFetchEmployeesStatusTbl = /* GraphQL */ `
  query GetSpkISolvedFetchEmployeesStatusTbl($id: ID!) {
    getSpkISolvedFetchEmployeesStatusTbl(id: $id) {
      id
      allSort
      startDateTime
      endDateTime
      createdById
      createdBy {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      lambdaStatus
      statusResults
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkISolvedFetchEmployeesStatusTbls = /* GraphQL */ `
  query ListSpkISolvedFetchEmployeesStatusTbls(
    $filter: ModelSpkISolvedFetchEmployeesStatusTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpkISolvedFetchEmployeesStatusTbls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        startDateTime
        endDateTime
        createdById
        lambdaStatus
        statusResults
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpkAppGlobalConfigTbl = /* GraphQL */ `
  query GetSpkAppGlobalConfigTbl($configKey: String!) {
    getSpkAppGlobalConfigTbl(configKey: $configKey) {
      configKey
      configValue
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpkAppGlobalConfigTbls = /* GraphQL */ `
  query ListSpkAppGlobalConfigTbls(
    $configKey: String
    $filter: ModelSpkAppGlobalConfigTblFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSpkAppGlobalConfigTbls(
      configKey: $configKey
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        configKey
        configValue
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPrimaryUnitAuxillaryUnits = /* GraphQL */ `
  query GetPrimaryUnitAuxillaryUnits($id: ID!) {
    getPrimaryUnitAuxillaryUnits(id: $id) {
      id
      spkAuxillaryUnitTblId
      spkPrimaryUnitTblId
      spkAuxillaryUnitTbl {
        id
        allSort
        name
        description
        isBillable
        rateDescription
        price
        priceCodeId
        isMaterialExpense
        isActive
        createdAt
        updatedAt
        __typename
      }
      spkPrimaryUnitTbl {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPrimaryUnitAuxillaryUnits = /* GraphQL */ `
  query ListPrimaryUnitAuxillaryUnits(
    $filter: ModelPrimaryUnitAuxillaryUnitsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPrimaryUnitAuxillaryUnits(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spkAuxillaryUnitTblId
        spkPrimaryUnitTblId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInspectionPointSubType = /* GraphQL */ `
  query GetInspectionPointSubType($id: ID!) {
    getInspectionPointSubType(id: $id) {
      id
      spkUnitSubTypeTblId
      spkUnitInspectionPointTblId
      spkUnitSubTypeTbl {
        id
        allSort
        typeId
        name
        maintenanceName
        priceCodeId
        qbExpenseCategoryId
        createdAt
        updatedAt
        __typename
      }
      spkUnitInspectionPointTbl {
        id
        order
        topic
        point
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInspectionPointSubTypes = /* GraphQL */ `
  query ListInspectionPointSubTypes(
    $filter: ModelInspectionPointSubTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInspectionPointSubTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spkUnitSubTypeTblId
        spkUnitInspectionPointTblId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allTeamMembersSortableByLastName = /* GraphQL */ `
  query AllTeamMembersSortableByLastName(
    $allSort: String!
    $lastName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkTeamMemberTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allTeamMembersSortableByLastName(
      allSort: $allSort
      lastName: $lastName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const teamMemberByLoginEmail = /* GraphQL */ `
  query TeamMemberByLoginEmail(
    $loginEmail: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkTeamMemberTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teamMemberByLoginEmail(
      loginEmail: $loginEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const teamMemberByLastName = /* GraphQL */ `
  query TeamMemberByLastName(
    $lastName: String!
    $firstName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkTeamMemberTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teamMemberByLastName(
      lastName: $lastName
      firstName: $firstName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const teamMembersByDivisionId = /* GraphQL */ `
  query TeamMembersByDivisionId(
    $divisionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkTeamMemberTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teamMembersByDivisionId(
      divisionId: $divisionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const teamMemberByEmployeeNumber = /* GraphQL */ `
  query TeamMemberByEmployeeNumber(
    $employeeNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkTeamMemberTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teamMemberByEmployeeNumber(
      employeeNumber: $employeeNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        loginEmail
        isolvedEmail
        firstName
        middleName
        lastName
        goesBy
        dob
        hireDate
        billableDivisionJobClassId
        doTrackPunches
        djtHideByDefault
        divisionId
        multiDivisions
        termDate
        imgUrl
        avatarId
        memberOf
        badgeNumber
        employmentCategoryCode
        employeeNumber
        addStreet
        addCity
        addState
        addZipcode
        phoneNum
        isActive
        isLocked
        isGlobalAdmin
        emergcyContName
        emergcyContPhone
        emergcyContSecName
        emergcyContSecPhone
        canTransfer
        isOnboarded
        isERPUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const jobClassRatesByDivisionId = /* GraphQL */ `
  query JobClassRatesByDivisionId(
    $divisionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTJobClassRateTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    jobClassRatesByDivisionId(
      divisionId: $divisionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        divisionPosition
        className
        appDisplayName
        invoiceDisplayName
        unionDisplayName
        hourlyRate
        overtimeRate
        divisionId
        isActive
        isHiddenByDefault
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allDivisionsSortableByName = /* GraphQL */ `
  query AllDivisionsSortableByName(
    $allSort: String!
    $prettyname: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDivisionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allDivisionsSortableByName(
      allSort: $allSort
      prettyname: $prettyname
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const divisionsByRegionId = /* GraphQL */ `
  query DivisionsByRegionId(
    $regionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDivisionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    divisionsByRegionId(
      regionId: $regionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        regionId
        isFeeder
        prettyId
        prettyname
        defaultQBClass
        addStreet
        addCity
        addState
        addZipcode
        superVisorId
        asstSupervisorId
        djtCanPerDiem
        djtPerDiemAmt
        djtTrackLabor
        djtTrackEquipment
        djtTrackMaterial
        djtRentalMsgActive
        djtRentalMsg
        djtAllowsWO
        djtOneClient
        djtAllowsEmailCC
        djtDefaultStartTime
        djtDefaultEndTime
        djtDefaultLunchDuration
        djtEnableAllSupervisors
        djtMergeMaterialEquipment
        djtShowDownloadPDF
        laborMultiplier
        isActive
        isSafeInspection
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const leaveRequestsByEmployeeNumber = /* GraphQL */ `
  query LeaveRequestsByEmployeeNumber(
    $employeeNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkLeaveRequestTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    leaveRequestsByEmployeeNumber(
      employeeNumber: $employeeNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        employeeNumber
        leaveDate
        category
        hours
        status
        requestDateTime
        dateApproved
        department
        modifiedBy
        comments
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const priviledgedDataByTeamMemberId = /* GraphQL */ `
  query PriviledgedDataByTeamMemberId(
    $teamMemberId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkTeamMemberPrivilegedTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    priviledgedDataByTeamMemberId(
      teamMemberId: $teamMemberId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teamMemberId
        docDataTypeId
        uploadedDocumentId
        identityDocumentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const uploadedDocumentByKey = /* GraphQL */ `
  query UploadedDocumentByKey(
    $key: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUploadedDocumentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    uploadedDocumentByKey(
      key: $key
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        identityId
        key
        bucket
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitPopularityByDivisionId = /* GraphQL */ `
  query UnitPopularityByDivisionId(
    $divisionId: ID!
    $popularity: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTUnitPopularityTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitPopularityByDivisionId(
      divisionId: $divisionId
      popularity: $popularity
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        divisionIdUnitId
        divisionId
        unitId
        popularity
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeePopularityByDeptEmpComposite = /* GraphQL */ `
  query EmployeePopularityByDeptEmpComposite(
    $deptEmpComposite: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTEmployeePopularityTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeePopularityByDeptEmpComposite(
      deptEmpComposite: $deptEmpComposite
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        department
        employeeNumber
        deptEmpComposite
        popularity
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtDuplicatesByParentId = /* GraphQL */ `
  query DjtDuplicatesByParentId(
    $duplicateOfId: ID!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtDuplicatesByParentId(
      duplicateOfId: $duplicateOfId
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtsByParentId = /* GraphQL */ `
  query DjtsByParentId(
    $parentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtsByParentId(
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDivisionTeamMemberComposite = /* GraphQL */ `
  query DjtByDivisionTeamMemberComposite(
    $djtDivisionTeamMember: String!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDivisionTeamMemberComposite(
      djtDivisionTeamMember: $djtDivisionTeamMember
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDivisionTeamMemberClientComposite = /* GraphQL */ `
  query DjtByDivisionTeamMemberClientComposite(
    $djtDivisionTeamMemberClient: String!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDivisionTeamMemberClientComposite(
      djtDivisionTeamMemberClient: $djtDivisionTeamMemberClient
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDateDivision = /* GraphQL */ `
  query DjtByDateDivision(
    $djtDateDivison: String!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDateDivision(
      djtDateDivison: $djtDateDivison
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDate = /* GraphQL */ `
  query DjtByDate(
    $djtDate: AWSDate!
    $djtDivisionIdDjtClientId: ModelSpkDailyJobTicketTblDjtByDateIndexCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDate(
      djtDate: $djtDate
      djtDivisionIdDjtClientId: $djtDivisionIdDjtClientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDivisionId = /* GraphQL */ `
  query DjtByDivisionId(
    $djtDivisionId: ID!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDivisionId(
      djtDivisionId: $djtDivisionId
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByClientId = /* GraphQL */ `
  query DjtByClientId(
    $djtClientId: ID!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByClientId(
      djtClientId: $djtClientId
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDivisionIdClientId = /* GraphQL */ `
  query DjtByDivisionIdClientId(
    $djtDivisionClient: String!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDivisionIdClientId(
      djtDivisionClient: $djtDivisionClient
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDivisionStatusComposite = /* GraphQL */ `
  query DjtByDivisionStatusComposite(
    $djtDivisionStatus: String!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDivisionStatusComposite(
      djtDivisionStatus: $djtDivisionStatus
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDivisionTeamMemberStatusComposite = /* GraphQL */ `
  query DjtByDivisionTeamMemberStatusComposite(
    $djtDivisionTeamMemberStatus: String!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDivisionTeamMemberStatusComposite(
      djtDivisionTeamMemberStatus: $djtDivisionTeamMemberStatus
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDivisionTeamMemberClientStatus = /* GraphQL */ `
  query DjtByDivisionTeamMemberClientStatus(
    $djtDivisionTeamMemberClientStatus: String!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDivisionTeamMemberClientStatus(
      djtDivisionTeamMemberClientStatus: $djtDivisionTeamMemberClientStatus
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByDivisionClientStatus = /* GraphQL */ `
  query DjtByDivisionClientStatus(
    $djtDivisionClientStatus: String!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByDivisionClientStatus(
      djtDivisionClientStatus: $djtDivisionClientStatus
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByClientDatePOWO = /* GraphQL */ `
  query DjtByClientDatePOWO(
    $djtClientDateWOPO: String!
    $djtDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByClientDatePOWO(
      djtClientDateWOPO: $djtClientDateWOPO
      djtDate: $djtDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtByCurrentStatusId = /* GraphQL */ `
  query DjtByCurrentStatusId(
    $currentStatusId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDailyJobTicketTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtByCurrentStatusId(
      currentStatusId: $currentStatusId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isActive
        isDuplicate
        isParent
        duplicateOfId
        parentId
        teamMemberId
        createDateTime
        djtDivisionTeamMember
        djtDivisionTeamMemberClient
        djtDateDivison
        djtDate
        djtDivisionId
        djtClientId
        djtDivisionClient
        djtDivisionStatus
        djtDivisionTeamMemberStatus
        djtDivisionTeamMemberClientStatus
        djtDivisionClientStatus
        djtClientContactId
        djtRequiresClientAuth
        djtClientAuthName
        djtClientAuthSignatureId
        djtSupervisorAuthName
        djtSupervisorAuthSignatureId
        djtNonContractPO
        djtClientPO
        specialInstructions
        isEstimate
        doNotBill
        doNotBillDescription
        djtPendingPO
        djtPOid
        djtWO
        djtWODescription
        djtClientDateWOPO
        djtNotes
        djtLocation
        djtLaborTotal
        djtEquipmentTotal
        djtMaterialTotal
        djtTotalBilled
        djtBillingNotes
        isSubmitted
        isAuthorized
        authorizedById
        autorizedDateTime
        isExported
        exportedById
        exportedDateTime
        isPaid
        isClosed
        isSubmitValid
        lastStep
        isPushedToQB
        pushedToQBBy
        pushedToQBDateTime
        currentStatusId
        pdfFilename
        attachableObjId
        showLaborHours
        isDeleted
        attachedContractId
        bouncedAdminReason
        bouncedSupervisorRespone
        verifiedComplete
        verifiedById
        mergeMaterialEquipment
        invoiceNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const equipmentByDJTId = /* GraphQL */ `
  query EquipmentByDJTId(
    $djtId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTEquipmentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    equipmentByDJTId(
      djtId: $djtId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        isActive
        isPrimary
        unitId
        unitCode
        isCustom
        isAuxillary
        auxUnitId
        isAuxChild
        auxChildOfParentId
        date
        billableDescription
        totalBilled
        requiresDriver
        requiresOperator
        statusId
        quantity
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitByDJTUnitId = /* GraphQL */ `
  query UnitByDJTUnitId(
    $unitId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTEquipmentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitByDJTUnitId(
      unitId: $unitId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        isActive
        isPrimary
        unitId
        unitCode
        isCustom
        isAuxillary
        auxUnitId
        isAuxChild
        auxChildOfParentId
        date
        billableDescription
        totalBilled
        requiresDriver
        requiresOperator
        statusId
        quantity
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const billableAuxillaryUnitsByDJTId = /* GraphQL */ `
  query BillableAuxillaryUnitsByDJTId(
    $djtId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTBillableAuxUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    billableAuxillaryUnitsByDJTId(
      djtId: $djtId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        auxillaryUnitId
        djtEquipmnetId
        billableUnitRateTypeId
        billedForQuantity
        billedForPrice
        billedForAmount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const billableAuxillaryUnitsByEquipmentId = /* GraphQL */ `
  query BillableAuxillaryUnitsByEquipmentId(
    $djtEquipmnetId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTBillableAuxUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    billableAuxillaryUnitsByEquipmentId(
      djtEquipmnetId: $djtEquipmnetId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        auxillaryUnitId
        djtEquipmnetId
        billableUnitRateTypeId
        billedForQuantity
        billedForPrice
        billedForAmount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const driverByDjtId = /* GraphQL */ `
  query DriverByDjtId(
    $djtId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTDriverTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    driverByDjtId(
      djtId: $djtId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        drivenById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const driverByUnitId = /* GraphQL */ `
  query DriverByUnitId(
    $unitId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTDriverTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    driverByUnitId(
      unitId: $unitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        drivenById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const driverByDJTEquipmentId = /* GraphQL */ `
  query DriverByDJTEquipmentId(
    $djtEquipmentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTDriverTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    driverByDJTEquipmentId(
      djtEquipmentId: $djtEquipmentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        drivenById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const driverByDrivenByIdId = /* GraphQL */ `
  query DriverByDrivenByIdId(
    $drivenById: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTDriverTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    driverByDrivenByIdId(
      drivenById: $drivenById
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        drivenById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const operatorByDjtId = /* GraphQL */ `
  query OperatorByDjtId(
    $djtId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTOperatorTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operatorByDjtId(
      djtId: $djtId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        operatedById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const operatorByUnitId = /* GraphQL */ `
  query OperatorByUnitId(
    $unitId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTOperatorTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operatorByUnitId(
      unitId: $unitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        operatedById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const operatorByDJTEquipmentId = /* GraphQL */ `
  query OperatorByDJTEquipmentId(
    $djtEquipmentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTOperatorTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operatorByDJTEquipmentId(
      djtEquipmentId: $djtEquipmentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        operatedById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const operatorByOperatedByIdId = /* GraphQL */ `
  query OperatorByOperatedByIdId(
    $operatedById: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTOperatorTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operatorByOperatedByIdId(
      operatedById: $operatedById
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        unitId
        djtEquipmentId
        date
        operatedById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allAuxillaryUnitsSortableByName = /* GraphQL */ `
  query AllAuxillaryUnitsSortableByName(
    $allSort: String!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkAuxillaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allAuxillaryUnitsSortableByName(
      allSort: $allSort
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        description
        isBillable
        rateDescription
        price
        priceCodeId
        isMaterialExpense
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const auxUnitByPriceCodeId = /* GraphQL */ `
  query AuxUnitByPriceCodeId(
    $priceCodeId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkAuxillaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    auxUnitByPriceCodeId(
      priceCodeId: $priceCodeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        description
        isBillable
        rateDescription
        price
        priceCodeId
        isMaterialExpense
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const billableMaterialsByDivisionId = /* GraphQL */ `
  query BillableMaterialsByDivisionId(
    $divisionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTDefaultBillableMaterialTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    billableMaterialsByDivisionId(
      divisionId: $divisionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        divisionId
        order
        description
        notes
        price
        quantity
        isActive
        doShowOnLoad
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const statementVendorByVendorTypeKey = /* GraphQL */ `
  query StatementVendorByVendorTypeKey(
    $vendorTypeKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkStatementVendorMapTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    statementVendorByVendorTypeKey(
      vendorTypeKey: $vendorTypeKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        vendorName
        vendorTypeKey
        sellsDiesel
        qbVendorId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allStatementQuickBooksVendorSortableByQBVendorName = /* GraphQL */ `
  query AllStatementQuickBooksVendorSortableByQBVendorName(
    $allSort: String!
    $qbDisplayNameLower: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkStatementQuickBooksVendorTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allStatementQuickBooksVendorSortableByQBVendorName(
      allSort: $allSort
      qbDisplayNameLower: $qbDisplayNameLower
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        qbId
        allSort
        qbDisplayName
        qbDisplayNameLower
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const statementVendorByQBVendorNameLower = /* GraphQL */ `
  query StatementVendorByQBVendorNameLower(
    $qbDisplayNameLower: String!
    $qbDisplayName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkStatementQuickBooksVendorTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    statementVendorByQBVendorNameLower(
      qbDisplayNameLower: $qbDisplayNameLower
      qbDisplayName: $qbDisplayName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        qbId
        allSort
        qbDisplayName
        qbDisplayNameLower
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allStatementVendorMapTypeSortableByVendorType = /* GraphQL */ `
  query AllStatementVendorMapTypeSortableByVendorType(
    $allSort: String!
    $vendorType: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkStatementVendorMapTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allStatementVendorMapTypeSortableByVendorType(
      allSort: $allSort
      vendorType: $vendorType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        vendorType
        allSort
        appDisplayName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allStatementStatusSortableByStatus = /* GraphQL */ `
  query AllStatementStatusSortableByStatus(
    $allSort: String!
    $statementStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkStatementStatusTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allStatementStatusSortableByStatus(
      allSort: $allSort
      statementStatus: $statementStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        statementStatus
        allSort
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const statementDocumentUnitByUnitId = /* GraphQL */ `
  query StatementDocumentUnitByUnitId(
    $unitId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkStatementDocumentUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    statementDocumentUnitByUnitId(
      unitId: $unitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        transactionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const statementDocumentUnitByTransactionId = /* GraphQL */ `
  query StatementDocumentUnitByTransactionId(
    $transactionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkStatementDocumentUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    statementDocumentUnitByTransactionId(
      transactionId: $transactionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        transactionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allCreditCardTeamMemberMapId = /* GraphQL */ `
  query AllCreditCardTeamMemberMapId(
    $allSort: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCreditCardTeamMemberMapTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allCreditCardTeamMemberMapId(
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        qbChartOfAccountsId
        allSort
        teamMemberId
        isActive
        isDefault
        cardLastFour
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const creditCardTeamMemberByTeamMemberId = /* GraphQL */ `
  query CreditCardTeamMemberByTeamMemberId(
    $teamMemberId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCreditCardTeamMemberMapTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    creditCardTeamMemberByTeamMemberId(
      teamMemberId: $teamMemberId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        qbChartOfAccountsId
        allSort
        teamMemberId
        isActive
        isDefault
        cardLastFour
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const creditCardTeamMemberByCardLastFour = /* GraphQL */ `
  query CreditCardTeamMemberByCardLastFour(
    $cardLastFour: String!
    $allSort: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCreditCardTeamMemberMapTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    creditCardTeamMemberByCardLastFour(
      cardLastFour: $cardLastFour
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        qbChartOfAccountsId
        allSort
        teamMemberId
        isActive
        isDefault
        cardLastFour
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allCreditCardChartOfAccountsSortableByQBChartOfAccountsName = /* GraphQL */ `
  query AllCreditCardChartOfAccountsSortableByQBChartOfAccountsName(
    $allSort: String!
    $qbChartOfAccountsName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCreditCardChartOfAccountsTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allCreditCardChartOfAccountsSortableByQBChartOfAccountsName(
      allSort: $allSort
      qbChartOfAccountsName: $qbChartOfAccountsName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        qbChartOfAccountsId
        allSort
        qbChartOfAccountsName
        qbChartOfAccountsFullyQualifiedName
        qbChartOfAccountsActive
        cardLastFour
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allPrimaryUnits = /* GraphQL */ `
  query AllPrimaryUnits(
    $allSort: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allPrimaryUnits(
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitByCode = /* GraphQL */ `
  query PrimaryUnitByCode(
    $code: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitsByTag = /* GraphQL */ `
  query PrimaryUnitsByTag(
    $tag: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitsByTag(
      tag: $tag
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitsByVin = /* GraphQL */ `
  query PrimaryUnitsByVin(
    $vin: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitsByVin(
      vin: $vin
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitsByMarriageId = /* GraphQL */ `
  query PrimaryUnitsByMarriageId(
    $marriageId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitsByMarriageId(
      marriageId: $marriageId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitsByTypeId = /* GraphQL */ `
  query PrimaryUnitsByTypeId(
    $typeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitsByTypeId(
      typeId: $typeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitsBySubTypeId = /* GraphQL */ `
  query PrimaryUnitsBySubTypeId(
    $subTypeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitsBySubTypeId(
      subTypeId: $subTypeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitsByCurrentLocationId = /* GraphQL */ `
  query PrimaryUnitsByCurrentLocationId(
    $currentLocation: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitsByCurrentLocationId(
      currentLocation: $currentLocation
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        code
        codeSortable
        name
        year
        make
        model
        color
        irpiftaRegistered
        tag
        vin
        serial
        teamMemberId
        isMarried
        marriageId
        purchDate
        purchAmt
        purchNotes
        soldDate
        soldAmt
        soldNotes
        isActive
        billRateDay
        billRateHour
        typeId
        subTypeId
        seatAxle
        cgvw
        unladWt
        isDOTReg
        reqCDLDriver
        unitSmallImageId
        unitMediumImageId
        currentLocation
        isInOperation
        canTransfer
        isInspectedDaily
        requiresOperator
        requiresDriver
        qbExpenseCategoryId
        qbExpenseCategoryNumber
        qbExpenseCategory
        iconId
        odometer
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allIFTAFuelTaxTracking = /* GraphQL */ `
  query AllIFTAFuelTaxTracking(
    $allSort: String!
    $statementDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkIFTAFuelTaxTrackingTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allIFTAFuelTaxTracking(
      allSort: $allSort
      statementDate: $statementDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        statementDate
        transactionId
        yearQuarter
        unitId
        teamMemberId
        stateTwoChar
        gallons
        odometer
        isApproved
        approvedById
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IFTAFuelTaxTrackingByYearQuarter = /* GraphQL */ `
  query IFTAFuelTaxTrackingByYearQuarter(
    $yearQuarter: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkIFTAFuelTaxTrackingTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IFTAFuelTaxTrackingByYearQuarter(
      yearQuarter: $yearQuarter
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        statementDate
        transactionId
        yearQuarter
        unitId
        teamMemberId
        stateTwoChar
        gallons
        odometer
        isApproved
        approvedById
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitCodeByQrCodeValue = /* GraphQL */ `
  query UnitCodeByQrCodeValue(
    $qrCodeValue: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitQrMapTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitCodeByQrCodeValue(
      qrCodeValue: $qrCodeValue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        unitCode
        qrCodeValue
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allUnitTypesSortableByName = /* GraphQL */ `
  query AllUnitTypesSortableByName(
    $allSort: String!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allUnitTypesSortableByName(
      allSort: $allSort
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        maintenanceName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allUnitSubTypesSortableByName = /* GraphQL */ `
  query AllUnitSubTypesSortableByName(
    $allSort: String!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitSubTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allUnitSubTypesSortableByName(
      allSort: $allSort
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        typeId
        name
        maintenanceName
        priceCodeId
        qbExpenseCategoryId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitSubTypesByTypeId = /* GraphQL */ `
  query UnitSubTypesByTypeId(
    $typeId: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitSubTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitSubTypesByTypeId(
      typeId: $typeId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        typeId
        name
        maintenanceName
        priceCodeId
        qbExpenseCategoryId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitSubTypeByPriceCodeId = /* GraphQL */ `
  query UnitSubTypeByPriceCodeId(
    $priceCodeId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitSubTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitSubTypeByPriceCodeId(
      priceCodeId: $priceCodeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        typeId
        name
        maintenanceName
        priceCodeId
        qbExpenseCategoryId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitSubTypeByQBExpenseCategoryId = /* GraphQL */ `
  query UnitSubTypeByQBExpenseCategoryId(
    $qbExpenseCategoryId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitSubTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitSubTypeByQBExpenseCategoryId(
      qbExpenseCategoryId: $qbExpenseCategoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        typeId
        name
        maintenanceName
        priceCodeId
        qbExpenseCategoryId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitPriceCodeByDivisionId = /* GraphQL */ `
  query UnitPriceCodeByDivisionId(
    $divisionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitPriceListTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitPriceCodeByDivisionId(
      divisionId: $divisionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        priceCodeDivision
        price
        year
        rateTypeId
        name
        divisionId
        divisionYear
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitPriceCodeByDivisionYear = /* GraphQL */ `
  query UnitPriceCodeByDivisionYear(
    $divisionYear: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitPriceListTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitPriceCodeByDivisionYear(
      divisionYear: $divisionYear
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        priceCodeDivision
        price
        year
        rateTypeId
        name
        divisionId
        divisionYear
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitSubTypePriceCodeByDivisionId = /* GraphQL */ `
  query UnitSubTypePriceCodeByDivisionId(
    $divisionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitSubTypePriceCodeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitSubTypePriceCodeByDivisionId(
      divisionId: $divisionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        priceCode
        price
        year
        rateTypeId
        name
        divisionId
        divisionYear
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitSubTypePriceCodeByDivisionYear = /* GraphQL */ `
  query UnitSubTypePriceCodeByDivisionYear(
    $divisionYear: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitSubTypePriceCodeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitSubTypePriceCodeByDivisionYear(
      divisionYear: $divisionYear
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        priceCode
        price
        year
        rateTypeId
        name
        divisionId
        divisionYear
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const institutionsByUserId = /* GraphQL */ `
  query InstitutionsByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidInstitutionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    institutionsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        accessToken
        institutionId
        institution
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidTransactionByPreviousUpdate = /* GraphQL */ `
  query PlaidTransactionByPreviousUpdate(
    $previousUpdate: String!
    $lastUpdated: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidSyncTransactionCursorTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidTransactionByPreviousUpdate(
      previousUpdate: $previousUpdate
      lastUpdated: $lastUpdated
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cursor
        lastUpdated
        previousUpdate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capOneTransactionsByCardByDate = /* GraphQL */ `
  query CapOneTransactionsByCardByDate(
    $accountNumber: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidCreditCardTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capOneTransactionsByCardByDate(
      accountNumber: $accountNumber
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        capitalOneCreditCardTransactionReceiptId
        accountNumber
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        accountId
        date
        amount
        merchantEntityId
        merchantEntityName
        store
        categoryId
        category
        location
        paymentChannel
        transactionId
        transactionType
        status
        approvedById
        billingPeriod
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidCreditCardTransactionByDate = /* GraphQL */ `
  query PlaidCreditCardTransactionByDate(
    $date: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidCreditCardTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidCreditCardTransactionByDate(
      date: $date
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        capitalOneCreditCardTransactionReceiptId
        accountNumber
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        accountId
        date
        amount
        merchantEntityId
        merchantEntityName
        store
        categoryId
        category
        location
        paymentChannel
        transactionId
        transactionType
        status
        approvedById
        billingPeriod
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidCreditCardTransactionByStatus = /* GraphQL */ `
  query PlaidCreditCardTransactionByStatus(
    $status: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidCreditCardTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidCreditCardTransactionByStatus(
      status: $status
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        capitalOneCreditCardTransactionReceiptId
        accountNumber
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        accountId
        date
        amount
        merchantEntityId
        merchantEntityName
        store
        categoryId
        category
        location
        paymentChannel
        transactionId
        transactionType
        status
        approvedById
        billingPeriod
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidCreditCardTransactionByStatusAndAccountNumber = /* GraphQL */ `
  query PlaidCreditCardTransactionByStatusAndAccountNumber(
    $status: String!
    $dateAccountNumber: ModelSpkPlaidCreditCardTransactionTblPlaidCreditCardTransactionByStatusAndAccountNumberIndexCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidCreditCardTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidCreditCardTransactionByStatusAndAccountNumber(
      status: $status
      dateAccountNumber: $dateAccountNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        capitalOneCreditCardTransactionReceiptId
        accountNumber
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        accountId
        date
        amount
        merchantEntityId
        merchantEntityName
        store
        categoryId
        category
        location
        paymentChannel
        transactionId
        transactionType
        status
        approvedById
        billingPeriod
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidCreditCardTransactionByStatusAccountNumber = /* GraphQL */ `
  query PlaidCreditCardTransactionByStatusAccountNumber(
    $status: String!
    $accountNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidCreditCardTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidCreditCardTransactionByStatusAccountNumber(
      status: $status
      accountNumber: $accountNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        capitalOneCreditCardTransactionReceiptId
        accountNumber
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        accountId
        date
        amount
        merchantEntityId
        merchantEntityName
        store
        categoryId
        category
        location
        paymentChannel
        transactionId
        transactionType
        status
        approvedById
        billingPeriod
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidCreditCardTransactionByBillingPeriod = /* GraphQL */ `
  query PlaidCreditCardTransactionByBillingPeriod(
    $billingPeriod: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidCreditCardTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidCreditCardTransactionByBillingPeriod(
      billingPeriod: $billingPeriod
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        capitalOneCreditCardTransactionReceiptId
        accountNumber
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        accountId
        date
        amount
        merchantEntityId
        merchantEntityName
        store
        categoryId
        category
        location
        paymentChannel
        transactionId
        transactionType
        status
        approvedById
        billingPeriod
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneInstantNotificationByAllSort = /* GraphQL */ `
  query CapitalOneInstantNotificationByAllSort(
    $allSort: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneInstantNotificationTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneInstantNotificationByAllSort(
      allSort: $allSort
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        capitalOneCreditCardTransactionReceiptId
        plaidTransationId
        isMatched
        isSubmitted
        status
        lastFour
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneInstantNotificationByPlaidId = /* GraphQL */ `
  query CapitalOneInstantNotificationByPlaidId(
    $plaidTransationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneInstantNotificationTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneInstantNotificationByPlaidId(
      plaidTransationId: $plaidTransationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        capitalOneCreditCardTransactionReceiptId
        plaidTransationId
        isMatched
        isSubmitted
        status
        lastFour
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneInstantNotificationByLastFour = /* GraphQL */ `
  query CapitalOneInstantNotificationByLastFour(
    $lastFour: String!
    $purchaseDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneInstantNotificationTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneInstantNotificationByLastFour(
      lastFour: $lastFour
      purchaseDate: $purchaseDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        capitalOneCreditCardTransactionReceiptId
        plaidTransationId
        isMatched
        isSubmitted
        status
        lastFour
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneInstantNotificationByPurchaseDate = /* GraphQL */ `
  query CapitalOneInstantNotificationByPurchaseDate(
    $purchaseDate: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneInstantNotificationTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneInstantNotificationByPurchaseDate(
      purchaseDate: $purchaseDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        capitalOneCreditCardTransactionReceiptId
        plaidTransationId
        isMatched
        isSubmitted
        status
        lastFour
        purchaseDate
        purchaseMerchant
        purchaseAmount
        purchaseInstitution
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneCreditCardTransactionReceiptByCapitalOneInstantNotificationId = /* GraphQL */ `
  query CapitalOneCreditCardTransactionReceiptByCapitalOneInstantNotificationId(
    $capitalOneInstantNotificationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneCreditCardTransactionReceiptTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneCreditCardTransactionReceiptByCapitalOneInstantNotificationId(
      capitalOneInstantNotificationId: $capitalOneInstantNotificationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneCreditCardTransactionReceiptByPlaidCreditCardTransactionId = /* GraphQL */ `
  query CapitalOneCreditCardTransactionReceiptByPlaidCreditCardTransactionId(
    $plaidCreditCardTransactionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneCreditCardTransactionReceiptTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneCreditCardTransactionReceiptByPlaidCreditCardTransactionId(
      plaidCreditCardTransactionId: $plaidCreditCardTransactionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneCreditCardTransactionReceiptsByStatus = /* GraphQL */ `
  query CapitalOneCreditCardTransactionReceiptsByStatus(
    $allSort: String!
    $matchStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneCreditCardTransactionReceiptTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneCreditCardTransactionReceiptsByStatus(
      allSort: $allSort
      matchStatus: $matchStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneCreditCardTransactionReceiptByQBTransactionEntityId = /* GraphQL */ `
  query CapitalOneCreditCardTransactionReceiptByQBTransactionEntityId(
    $qbTransactionEntityId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneCreditCardTransactionReceiptTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneCreditCardTransactionReceiptByQBTransactionEntityId(
      qbTransactionEntityId: $qbTransactionEntityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneReceiptsByTeamMemberByMatchStatus = /* GraphQL */ `
  query CapitalOneReceiptsByTeamMemberByMatchStatus(
    $teamMemberId: ID!
    $matchStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneCreditCardTransactionReceiptTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneReceiptsByTeamMemberByMatchStatus(
      teamMemberId: $teamMemberId
      matchStatus: $matchStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneCreditCardTransactionReceiptByTransactionType = /* GraphQL */ `
  query CapitalOneCreditCardTransactionReceiptByTransactionType(
    $transactionType: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneCreditCardTransactionReceiptTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneCreditCardTransactionReceiptByTransactionType(
      transactionType: $transactionType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const capitalOneCreditCardTransactionReceiptByAmount = /* GraphQL */ `
  query CapitalOneCreditCardTransactionReceiptByAmount(
    $amount: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneCreditCardTransactionReceiptTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capitalOneCreditCardTransactionReceiptByAmount(
      amount: $amount
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        capitalOneInstantNotificationId
        plaidCreditCardTransactionId
        allSort
        matchStatus
        qbTransactionEntityId
        isReceiptUploaded
        quickbooksExpenseId
        teamMemberId
        divisionId
        clientId
        expenseCategoryId
        unitId
        iftaFuelTaxTrackId
        addedNotes
        hasIssue
        issue
        transactionType
        amount
        invoiceReceiptDate
        invoiceReceiptID
        statementTotal
        amountDue
        orderDate
        amountPaid
        gratuity
        vendorName
        dueDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const transactionReceiptDocumentLinksByReceiptId = /* GraphQL */ `
  query TransactionReceiptDocumentLinksByReceiptId(
    $receiptId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneTransactionReceiptDocumentLinkTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transactionReceiptDocumentLinksByReceiptId(
      receiptId: $receiptId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        receiptId
        uploadedDocumentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const transactionReceiptDocumentLinksByDocumentId = /* GraphQL */ `
  query TransactionReceiptDocumentLinksByDocumentId(
    $uploadedDocumentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCapitalOneTransactionReceiptDocumentLinkTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transactionReceiptDocumentLinksByDocumentId(
      uploadedDocumentId: $uploadedDocumentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        receiptId
        uploadedDocumentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidTransactionByAccountOwner = /* GraphQL */ `
  query PlaidTransactionByAccountOwner(
    $account_owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidTransactionByAccountOwner(
      account_owner: $account_owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        institution_id
        account_id
        account_owner
        amount
        authorized_date
        category
        date
        location
        merchant_entity_id
        name
        merchant_name
        payment_channel
        pending
        pending_transaction_id
        pending_transaction
        transaction_code
        transaction_id
        transaction_type
        cursorId
        matched
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidTransactionsByDate = /* GraphQL */ `
  query PlaidTransactionsByDate(
    $date: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidTransactionsByDate(
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        institution_id
        account_id
        account_owner
        amount
        authorized_date
        category
        date
        location
        merchant_entity_id
        name
        merchant_name
        payment_channel
        pending
        pending_transaction_id
        pending_transaction
        transaction_code
        transaction_id
        transaction_type
        cursorId
        matched
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidTransactionsById = /* GraphQL */ `
  query PlaidTransactionsById(
    $transaction_id: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidTransactionsById(
      transaction_id: $transaction_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        institution_id
        account_id
        account_owner
        amount
        authorized_date
        category
        date
        location
        merchant_entity_id
        name
        merchant_name
        payment_channel
        pending
        pending_transaction_id
        pending_transaction
        transaction_code
        transaction_id
        transaction_type
        cursorId
        matched
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidTransactionByCursorId = /* GraphQL */ `
  query PlaidTransactionByCursorId(
    $cursorId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidTransactionByCursorId(
      cursorId: $cursorId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        institution_id
        account_id
        account_owner
        amount
        authorized_date
        category
        date
        location
        merchant_entity_id
        name
        merchant_name
        payment_channel
        pending
        pending_transaction_id
        pending_transaction
        transaction_code
        transaction_id
        transaction_type
        cursorId
        matched
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidTransactionByMatched = /* GraphQL */ `
  query PlaidTransactionByMatched(
    $matched: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidTransactionByMatched(
      matched: $matched
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        institution_id
        account_id
        account_owner
        amount
        authorized_date
        category
        date
        location
        merchant_entity_id
        name
        merchant_name
        payment_channel
        pending
        pending_transaction_id
        pending_transaction
        transaction_code
        transaction_id
        transaction_type
        cursorId
        matched
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidPendingTransactionByCardNumber = /* GraphQL */ `
  query PlaidPendingTransactionByCardNumber(
    $cardNumber: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidPendingTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidPendingTransactionByCardNumber(
      cardNumber: $cardNumber
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cardNumber
        date
        merchant
        transactionType
        amount
        pendingSort
        postedTransactionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allPlaidPendingTransactionsSortableByDate = /* GraphQL */ `
  query AllPlaidPendingTransactionsSortableByDate(
    $pendingSort: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidPendingTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allPlaidPendingTransactionsSortableByDate(
      pendingSort: $pendingSort
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cardNumber
        date
        merchant
        transactionType
        amount
        pendingSort
        postedTransactionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plaidPendingTransactionByPostedTransactionId = /* GraphQL */ `
  query PlaidPendingTransactionByPostedTransactionId(
    $postedTransactionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPlaidPendingTransactionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plaidPendingTransactionByPostedTransactionId(
      postedTransactionId: $postedTransactionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cardNumber
        date
        merchant
        transactionType
        amount
        pendingSort
        postedTransactionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allQBExpenseCategoriesSortableByName = /* GraphQL */ `
  query AllQBExpenseCategoriesSortableByName(
    $allSort: String!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkQBExpenseCategoryTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allQBExpenseCategoriesSortableByName(
      allSort: $allSort
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        qbId
        allSort
        acctNum
        name
        appName
        isActive
        isVisible
        isIFTATracked
        isUnitRequired
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const contactByCompanyName = /* GraphQL */ `
  query ContactByCompanyName(
    $companyName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkContactTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contactByCompanyName(
      companyName: $companyName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMachineGenerated
        contactTypeId
        firstName
        middleName
        lastName
        companyName
        phone
        address
        email
        url
        notes
        isActive
        isDisplayed
        searchTags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitBillableRateByUnitId = /* GraphQL */ `
  query UnitBillableRateByUnitId(
    $unitId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTPrimaryUnitBillableRateTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitBillableRateByUnitId(
      unitId: $unitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        unitCode
        unitId
        hourlyRate
        shiftRate
        dayRate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allDjtClients = /* GraphQL */ `
  query AllDjtClients(
    $allSort: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTClientTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allDjtClients(
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtClientsByDivisionId = /* GraphQL */ `
  query DjtClientsByDivisionId(
    $divisionId: ID!
    $contactCompany: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTClientTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtClientsByDivisionId(
      divisionId: $divisionId
      contactCompany: $contactCompany
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtClientsByStaleAfterDate = /* GraphQL */ `
  query DjtClientsByStaleAfterDate(
    $staleAfterDate: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTClientTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtClientsByStaleAfterDate(
      staleAfterDate: $staleAfterDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        divisionId
        contactCompany
        clientURL
        clientBillingEmail
        contactName
        contactEmail
        contactPhone
        isActive
        isSyncedToQB
        qbId
        qbClassName
        qbClassId
        qbSandboxClassName
        qbSandboxClassId
        qbSandboxId
        qbDisplayName
        qbCustomer
        qbCompany
        qbStreetAddress
        qbCity
        qbState
        qbCountry
        qbZip
        qbPhone
        qbEmail
        qbCustomerType
        staleAfterDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const verifiedEmailDomainsByClientId = /* GraphQL */ `
  query VerifiedEmailDomainsByClientId(
    $clientId: ID!
    $domain: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTClientVerifiedEmailDomainTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    verifiedEmailDomainsByClientId(
      clientId: $clientId
      domain: $domain
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        domain
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const clientContactsByClientId = /* GraphQL */ `
  query ClientContactsByClientId(
    $clientId: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTClientContactTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    clientContactsByClientId(
      clientId: $clientId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        name
        email
        emailVerified
        phone
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const posByDivisionClient = /* GraphQL */ `
  query PosByDivisionClient(
    $poDivisionClient: String!
    $po: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTPOTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    posByDivisionClient(
      poDivisionClient: $poDivisionClient
      po: $po
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        divisionId
        djtClientId
        po
        poDivisionClient
        poLocation
        divisionClientPOHash
        poDescription
        poNotes
        isClosed
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const poByDivisionClientPO = /* GraphQL */ `
  query PoByDivisionClientPO(
    $divisionClientPOHash: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTPOTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    poByDivisionClientPO(
      divisionClientPOHash: $divisionClientPOHash
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        divisionId
        djtClientId
        po
        poDivisionClient
        poLocation
        divisionClientPOHash
        poDescription
        poNotes
        isClosed
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allDjtCurrentStatusesSortedByOrder = /* GraphQL */ `
  query AllDjtCurrentStatusesSortedByOrder(
    $allSort: String!
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTCurrentStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allDjtCurrentStatusesSortedByOrder(
      allSort: $allSort
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        order
        status
        statusCode
        statusGroup
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtStatusByStatusCode = /* GraphQL */ `
  query DjtStatusByStatusCode(
    $statusCode: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTCurrentStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtStatusByStatusCode(
      statusCode: $statusCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        order
        status
        statusCode
        statusGroup
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtStatusByStatusGroup = /* GraphQL */ `
  query DjtStatusByStatusGroup(
    $statusGroup: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTCurrentStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtStatusByStatusGroup(
      statusGroup: $statusGroup
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        order
        status
        statusCode
        statusGroup
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const clientContractsByClientId = /* GraphQL */ `
  query ClientContractsByClientId(
    $clientId: ID!
    $createDateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkClientContractTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    clientContractsByClientId(
      clientId: $clientId
      createDateTime: $createDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createDateTime
        clientId
        documentId
        createdById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtCurrentStatusJournalByDjtId = /* GraphQL */ `
  query DjtCurrentStatusJournalByDjtId(
    $djtId: ID!
    $createdDateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTCurrentStatusJournalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtCurrentStatusJournalByDjtId(
      djtId: $djtId
      createdDateTime: $createdDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        createdDateTime
        createdBy
        statusId
        note
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtCurrentStatusJournalByCreatorId = /* GraphQL */ `
  query DjtCurrentStatusJournalByCreatorId(
    $createdBy: ID!
    $createdDateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTCurrentStatusJournalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtCurrentStatusJournalByCreatorId(
      createdBy: $createdBy
      createdDateTime: $createdDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        createdDateTime
        createdBy
        statusId
        note
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const djtCurrentStatusJournalByStatusId = /* GraphQL */ `
  query DjtCurrentStatusJournalByStatusId(
    $statusId: ID!
    $createdDateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTCurrentStatusJournalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    djtCurrentStatusJournalByStatusId(
      statusId: $statusId
      createdDateTime: $createdDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        createdDateTime
        createdBy
        statusId
        note
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const laborByDJTId = /* GraphQL */ `
  query LaborByDJTId(
    $djtId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTLaborTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    laborByDJTId(
      djtId: $djtId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        isActive
        date
        teamMemberId
        customLaborName
        jobClassId
        startTime
        finishTime
        perDiemAmount
        lunchDuration
        straightTime
        overTime
        departmentEmployee
        totalPrice
        statusId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const laborByDJTTeamMemberId = /* GraphQL */ `
  query LaborByDJTTeamMemberId(
    $teamMemberId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTLaborTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    laborByDJTTeamMemberId(
      teamMemberId: $teamMemberId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        isActive
        date
        teamMemberId
        customLaborName
        jobClassId
        startTime
        finishTime
        perDiemAmount
        lunchDuration
        straightTime
        overTime
        departmentEmployee
        totalPrice
        statusId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const laborByDJTJobClassId = /* GraphQL */ `
  query LaborByDJTJobClassId(
    $jobClassId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTLaborTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    laborByDJTJobClassId(
      jobClassId: $jobClassId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        isActive
        date
        teamMemberId
        customLaborName
        jobClassId
        startTime
        finishTime
        perDiemAmount
        lunchDuration
        straightTime
        overTime
        departmentEmployee
        totalPrice
        statusId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ccEmailsByClientId = /* GraphQL */ `
  query CcEmailsByClientId(
    $clientId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTClientSummaryEmailCCEmailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ccEmailsByClientId(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        clientId
        addedById
        isVerified
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const billableRatesByDivisionId = /* GraphQL */ `
  query BillableRatesByDivisionId(
    $divisionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTJobClassBillableRateTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    billableRatesByDivisionId(
      divisionId: $divisionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        divisionClassNameHash
        className
        classDescription
        hourlyRate
        shiftRate
        overtimeRate
        divisionId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const materialsByDJTId = /* GraphQL */ `
  query MaterialsByDJTId(
    $djtId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkDJTMaterialTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    materialsByDJTId(
      djtId: $djtId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        djtId
        isActive
        date
        description
        price
        quantity
        totalPrice
        hasReceipt
        includeReceipt
        isCustom
        isDefault
        statusId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitImagesByUnitId = /* GraphQL */ `
  query UnitImagesByUnitId(
    $unitId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitImageTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitImagesByUnitId(
      unitId: $unitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        imageDescription
        createdDateTime
        createdById
        uploadedDocumentId
        unitDocumentTypeId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allPrimaryUnitInspectionQueue = /* GraphQL */ `
  query AllPrimaryUnitInspectionQueue(
    $allSort: String!
    $active: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitInspectionQueueTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allPrimaryUnitInspectionQueue(
      allSort: $allSort
      active: $active
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        divisionId
        unitId
        active
        code
        createdById
        claimedById
        createdOn
        claimedOn
        completedOn
        inspectedDateTime
        inspectedById
        inspectionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activePrimaryUnitInspectionByCode = /* GraphQL */ `
  query ActivePrimaryUnitInspectionByCode(
    $code: String!
    $active: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitInspectionQueueTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activePrimaryUnitInspectionByCode(
      code: $code
      active: $active
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        divisionId
        unitId
        active
        code
        createdById
        claimedById
        createdOn
        claimedOn
        completedOn
        inspectedDateTime
        inspectedById
        inspectionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const inspectedUnitsByDivisionByDateFailure = /* GraphQL */ `
  query InspectedUnitsByDivisionByDateFailure(
    $divisionDateForFailure: String!
    $failureCount: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitInspectionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inspectedUnitsByDivisionByDateFailure(
      divisionDateForFailure: $divisionDateForFailure
      failureCount: $failureCount
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        divisionDateForFailure
        divisionDate
        unitId
        inspectedOn
        inspectedAt
        inspectedById
        createdById
        divisionId
        dateUnit
        statusId
        failureCount
        timeToInspect
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const inspectedUnitsByDivisionByDate = /* GraphQL */ `
  query InspectedUnitsByDivisionByDate(
    $divisionDate: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitInspectionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inspectedUnitsByDivisionByDate(
      divisionDate: $divisionDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        divisionDateForFailure
        divisionDate
        unitId
        inspectedOn
        inspectedAt
        inspectedById
        createdById
        divisionId
        dateUnit
        statusId
        failureCount
        timeToInspect
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitInspectionsByUnitId = /* GraphQL */ `
  query UnitInspectionsByUnitId(
    $unitId: ID!
    $inspectedOn: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitInspectionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitInspectionsByUnitId(
      unitId: $unitId
      inspectedOn: $inspectedOn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        divisionDateForFailure
        divisionDate
        unitId
        inspectedOn
        inspectedAt
        inspectedById
        createdById
        divisionId
        dateUnit
        statusId
        failureCount
        timeToInspect
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitInspectionByDateByUnitId = /* GraphQL */ `
  query UnitInspectionByDateByUnitId(
    $dateUnit: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitInspectionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitInspectionByDateByUnitId(
      dateUnit: $dateUnit
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        divisionDateForFailure
        divisionDate
        unitId
        inspectedOn
        inspectedAt
        inspectedById
        createdById
        divisionId
        dateUnit
        statusId
        failureCount
        timeToInspect
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const completedInspectionsByUnitInspectionId = /* GraphQL */ `
  query CompletedInspectionsByUnitInspectionId(
    $unitInspectionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitCompletedInspectionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedInspectionsByUnitInspectionId(
      unitInspectionId: $unitInspectionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitInspectionId
        inspectionPointId
        didPass
        failedReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitDocumentsByUnitId = /* GraphQL */ `
  query UnitDocumentsByUnitId(
    $unitId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitDocumentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitDocumentsByUnitId(
      unitId: $unitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        createdById
        uploadedDateTime
        uploadedDocumentId
        unitDocumentTypeId
        unitIdUnitDocumentTypeId
        active
        isActive
        notes
        imageSetId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitsByUnitDocumentType = /* GraphQL */ `
  query UnitsByUnitDocumentType(
    $unitDocumentTypeId: ID!
    $uploadedDateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitDocumentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitsByUnitDocumentType(
      unitDocumentTypeId: $unitDocumentTypeId
      uploadedDateTime: $uploadedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        createdById
        uploadedDateTime
        uploadedDocumentId
        unitDocumentTypeId
        unitIdUnitDocumentTypeId
        active
        isActive
        notes
        imageSetId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitDocumentsByUnitIdUnitDocumentTypeId = /* GraphQL */ `
  query UnitDocumentsByUnitIdUnitDocumentTypeId(
    $unitIdUnitDocumentTypeId: String!
    $uploadedDateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitDocumentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitDocumentsByUnitIdUnitDocumentTypeId(
      unitIdUnitDocumentTypeId: $unitIdUnitDocumentTypeId
      uploadedDateTime: $uploadedDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        createdById
        uploadedDateTime
        uploadedDocumentId
        unitDocumentTypeId
        unitIdUnitDocumentTypeId
        active
        isActive
        notes
        imageSetId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitDocumentsByNotes = /* GraphQL */ `
  query UnitDocumentsByNotes(
    $notes: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitDocumentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitDocumentsByNotes(
      notes: $notes
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        createdById
        uploadedDateTime
        uploadedDocumentId
        unitDocumentTypeId
        unitIdUnitDocumentTypeId
        active
        isActive
        notes
        imageSetId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const uploadedDocumentsByGroupId = /* GraphQL */ `
  query UploadedDocumentsByGroupId(
    $imageSetId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitDocumentTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    uploadedDocumentsByGroupId(
      imageSetId: $imageSetId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        createdById
        uploadedDateTime
        uploadedDocumentId
        unitDocumentTypeId
        unitIdUnitDocumentTypeId
        active
        isActive
        notes
        imageSetId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allUnitDocumentTypes = /* GraphQL */ `
  query AllUnitDocumentTypes(
    $allSort: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitDocumentTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allUnitDocumentTypes(
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        group
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitDocumentTypesByGroup = /* GraphQL */ `
  query UnitDocumentTypesByGroup(
    $group: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitDocumentTypeTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitDocumentTypesByGroup(
      group: $group
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        group
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allPrimaryUnitStatus = /* GraphQL */ `
  query AllPrimaryUnitStatus(
    $allSort: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitStatusTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allPrimaryUnitStatus(
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        code
        allSort
        unitId
        statusId
        notes
        inService
        inServiceAlert
        divisionId
        lastInspected
        lastInspectedAt
        createdOn
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitsByStatusId = /* GraphQL */ `
  query PrimaryUnitsByStatusId(
    $statusId: ID!
    $divisionId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitStatusTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitsByStatusId(
      statusId: $statusId
      divisionId: $divisionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        code
        allSort
        unitId
        statusId
        notes
        inService
        inServiceAlert
        divisionId
        lastInspected
        lastInspectedAt
        createdOn
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitStatusByDivisionId = /* GraphQL */ `
  query PrimaryUnitStatusByDivisionId(
    $divisionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitStatusTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitStatusByDivisionId(
      divisionId: $divisionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        code
        allSort
        unitId
        statusId
        notes
        inService
        inServiceAlert
        divisionId
        lastInspected
        lastInspectedAt
        createdOn
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitHistoryByUnitId = /* GraphQL */ `
  query UnitHistoryByUnitId(
    $unitId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkUnitHistoryTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitHistoryByUnitId(
      unitId: $unitId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        statusId
        notes
        inService
        divisionId
        createdOn
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allUnitStatusOptions = /* GraphQL */ `
  query AllUnitStatusOptions(
    $allSort: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitStatusOptionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allUnitStatusOptions(
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        status
        adminOnly
        isAvailable
        doAlert
        alert
        order
        statusQuery
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitStatusByStatusQuery = /* GraphQL */ `
  query UnitStatusByStatusQuery(
    $statusQuery: String!
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPrimaryUnitStatusOptionTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitStatusByStatusQuery(
      statusQuery: $statusQuery
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        status
        adminOnly
        isAvailable
        doAlert
        alert
        order
        statusQuery
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allNavMenuItems = /* GraphQL */ `
  query AllNavMenuItems(
    $allSort: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkNavMenuTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allNavMenuItems(
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        menuItem
        menuClass
        linkTo
        menuAltText
        displayOrder
        isPhoneSafe
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const navMenuItemsByTeamMemberId = /* GraphQL */ `
  query NavMenuItemsByTeamMemberId(
    $tmId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkNavMenuUserTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    navMenuItemsByTeamMemberId(
      tmId: $tmId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tmId
        navMenuId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allNavCognitoGroups = /* GraphQL */ `
  query AllNavCognitoGroups(
    $allSort: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkNavCognitoGroupTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allNavCognitoGroups(
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        cognitoGroupId
        menuItemId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const menuItemsByCognitoGroupId = /* GraphQL */ `
  query MenuItemsByCognitoGroupId(
    $cognitoGroupId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkNavCognitoGroupTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    menuItemsByCognitoGroupId(
      cognitoGroupId: $cognitoGroupId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        cognitoGroupId
        menuItemId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cognitoGroupsByMenuItemId = /* GraphQL */ `
  query CognitoGroupsByMenuItemId(
    $menuItemId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkNavCognitoGroupTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cognitoGroupsByMenuItemId(
      menuItemId: $menuItemId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        cognitoGroupId
        menuItemId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allCognitoGroups = /* GraphQL */ `
  query AllCognitoGroups(
    $allSort: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCognitoGroupTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allCognitoGroups(
      allSort: $allSort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cognitoGroupIdByGroupName = /* GraphQL */ `
  query CognitoGroupIdByGroupName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkCognitoGroupTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cognitoGroupIdByGroupName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        name
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pubsubMessageStatusByStatus = /* GraphQL */ `
  query PubsubMessageStatusByStatus(
    $status: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPubSubMessageStatusTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pubsubMessageStatusByStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pubsubMessagesByTopicId = /* GraphQL */ `
  query PubsubMessagesByTopicId(
    $topicId: ID!
    $sentAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPubSubMessageTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pubsubMessagesByTopicId(
      topicId: $topicId
      sentAt: $sentAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subject
        message
        messageJSON
        fromId
        sentAt
        topicId
        publisherId
        publisherType
        statusId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const topicIdByTopicName = /* GraphQL */ `
  query TopicIdByTopicName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPubSubTopicTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    topicIdByTopicName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        nameCode
        categoryId
        subscribeGroups
        publishGroups
        createdById
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const topicIdByTopicNameCode = /* GraphQL */ `
  query TopicIdByTopicNameCode(
    $nameCode: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPubSubTopicTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    topicIdByTopicNameCode(
      nameCode: $nameCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        nameCode
        categoryId
        subscribeGroups
        publishGroups
        createdById
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pubsubCategoryByCode = /* GraphQL */ `
  query PubsubCategoryByCode(
    $code: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkPubSubTopicCategoryTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pubsubCategoryByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        desc
        code
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const iSolvedHoursByEmployeeNumber = /* GraphQL */ `
  query ISolvedHoursByEmployeeNumber(
    $employeeNumber: String!
    $workDay: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedHoursTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedHoursByEmployeeNumber(
      employeeNumber: $employeeNumber
      workDay: $workDay
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeNumber
        employeeName
        workDay
        totalHours
        departmentId
        departmentIdWorkDay
        departmentEmployeeNumber
        hours
        punchIn
        punchOut
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const iSolvedHoursByWorkDay = /* GraphQL */ `
  query ISolvedHoursByWorkDay(
    $workDay: AWSDate!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedHoursTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedHoursByWorkDay(
      workDay: $workDay
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeNumber
        employeeName
        workDay
        totalHours
        departmentId
        departmentIdWorkDay
        departmentEmployeeNumber
        hours
        punchIn
        punchOut
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const iSolvedHoursByDepartmentIdByWorkDate = /* GraphQL */ `
  query ISolvedHoursByDepartmentIdByWorkDate(
    $departmentIdWorkDay: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedHoursTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedHoursByDepartmentIdByWorkDate(
      departmentIdWorkDay: $departmentIdWorkDay
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeNumber
        employeeName
        workDay
        totalHours
        departmentId
        departmentIdWorkDay
        departmentEmployeeNumber
        hours
        punchIn
        punchOut
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allISolvedMapEmpNoTeamMember = /* GraphQL */ `
  query AllISolvedMapEmpNoTeamMember(
    $allSort: String!
    $employeeName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedMapEmpNoToTeamMemberTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allISolvedMapEmpNoTeamMember(
      allSort: $allSort
      employeeName: $employeeName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        employeeNumber
        allSort
        employeeName
        departmentId
        teamMemberId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const iSolvedEmployeeByTeamMemberId = /* GraphQL */ `
  query ISolvedEmployeeByTeamMemberId(
    $teamMemberId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedMapEmpNoToTeamMemberTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedEmployeeByTeamMemberId(
      teamMemberId: $teamMemberId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        employeeNumber
        allSort
        employeeName
        departmentId
        teamMemberId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const allISolvedMappedDepartments = /* GraphQL */ `
  query AllISolvedMappedDepartments(
    $allSort: String!
    $departmentCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedMapDepartToDivTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allISolvedMappedDepartments(
      allSort: $allSort
      departmentCode: $departmentCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        departmentCode
        departmentName
        divisionId
        workLocation
        isPrimary
        divisionOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const iSolvedDivisionByDepartmentCode = /* GraphQL */ `
  query ISolvedDivisionByDepartmentCode(
    $departmentCode: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedMapDepartToDivTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedDivisionByDepartmentCode(
      departmentCode: $departmentCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        departmentCode
        departmentName
        divisionId
        workLocation
        isPrimary
        divisionOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const iSolvedDepartmentByDivisionId = /* GraphQL */ `
  query ISolvedDepartmentByDivisionId(
    $divisionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedMapDepartToDivTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedDepartmentByDivisionId(
      divisionId: $divisionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        departmentCode
        departmentName
        divisionId
        workLocation
        isPrimary
        divisionOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const iSolvedDailyPunchesByDate = /* GraphQL */ `
  query ISolvedDailyPunchesByDate(
    $punchDate: AWSDate!
    $dateDepartmentEmployeeTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedDailyDepartmentPunchesTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedDailyPunchesByDate(
      punchDate: $punchDate
      dateDepartmentEmployeeTime: $dateDepartmentEmployeeTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        dateDepartmentEmployeeTime
        punchDate
        punchTime
        departmentId
        dateDepartment
        iSolvedDatePunched
        iSolvedDepartmentName
        iSolvedEmployeeNumber
        departmentEmployee
        punchMode
        punchDateClassification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const iSolvedPunchesByDateByDepartmentShort = /* GraphQL */ `
  query ISolvedPunchesByDateByDepartmentShort(
    $dateDepartment: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedDailyDepartmentPunchesTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedPunchesByDateByDepartmentShort(
      dateDepartment: $dateDepartment
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        dateDepartmentEmployeeTime
        punchDate
        punchTime
        departmentId
        dateDepartment
        iSolvedDatePunched
        iSolvedDepartmentName
        iSolvedEmployeeNumber
        departmentEmployee
        punchMode
        punchDateClassification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const iSolvedEmployeePunchesByDate = /* GraphQL */ `
  query ISolvedEmployeePunchesByDate(
    $iSolvedEmployeeNumber: String!
    $punchDatePunchTime: ModelSpkISolvedDailyDepartmentPunchesTblISolvedEmployeePunchesByDateIndexCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedDailyDepartmentPunchesTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedEmployeePunchesByDate(
      iSolvedEmployeeNumber: $iSolvedEmployeeNumber
      punchDatePunchTime: $punchDatePunchTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        dateDepartmentEmployeeTime
        punchDate
        punchTime
        departmentId
        dateDepartment
        iSolvedDatePunched
        iSolvedDepartmentName
        iSolvedEmployeeNumber
        departmentEmployee
        punchMode
        punchDateClassification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const iSolvedEmployeePunchesByDateClassification = /* GraphQL */ `
  query ISolvedEmployeePunchesByDateClassification(
    $punchDateClassification: String!
    $iSolvedEmployeeNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedDailyDepartmentPunchesTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedEmployeePunchesByDateClassification(
      punchDateClassification: $punchDateClassification
      iSolvedEmployeeNumber: $iSolvedEmployeeNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        dateDepartmentEmployeeTime
        punchDate
        punchTime
        departmentId
        dateDepartment
        iSolvedDatePunched
        iSolvedDepartmentName
        iSolvedEmployeeNumber
        departmentEmployee
        punchMode
        punchDateClassification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      scannedCount
      count
      __typename
    }
  }
`;
export const allISolvedFetchEmployeesStatus = /* GraphQL */ `
  query AllISolvedFetchEmployeesStatus(
    $allSort: String!
    $startDateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedFetchEmployeesStatusTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    allISolvedFetchEmployeesStatus(
      allSort: $allSort
      startDateTime: $startDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        startDateTime
        endDateTime
        createdById
        lambdaStatus
        statusResults
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const iSolvedFetchEmployeesStatusByStatus = /* GraphQL */ `
  query ISolvedFetchEmployeesStatusByStatus(
    $lambdaStatus: StatusEnum!
    $startDateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpkISolvedFetchEmployeesStatusTblFilterInput
    $limit: Int
    $nextToken: String
  ) {
    iSolvedFetchEmployeesStatusByStatus(
      lambdaStatus: $lambdaStatus
      startDateTime: $startDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        allSort
        startDateTime
        endDateTime
        createdById
        lambdaStatus
        statusResults
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitAuxillaryUnitsBySpkAuxillaryUnitTblId = /* GraphQL */ `
  query PrimaryUnitAuxillaryUnitsBySpkAuxillaryUnitTblId(
    $spkAuxillaryUnitTblId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPrimaryUnitAuxillaryUnitsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitAuxillaryUnitsBySpkAuxillaryUnitTblId(
      spkAuxillaryUnitTblId: $spkAuxillaryUnitTblId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spkAuxillaryUnitTblId
        spkPrimaryUnitTblId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const primaryUnitAuxillaryUnitsBySpkPrimaryUnitTblId = /* GraphQL */ `
  query PrimaryUnitAuxillaryUnitsBySpkPrimaryUnitTblId(
    $spkPrimaryUnitTblId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPrimaryUnitAuxillaryUnitsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    primaryUnitAuxillaryUnitsBySpkPrimaryUnitTblId(
      spkPrimaryUnitTblId: $spkPrimaryUnitTblId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spkAuxillaryUnitTblId
        spkPrimaryUnitTblId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const inspectionPointSubTypesBySpkUnitSubTypeTblId = /* GraphQL */ `
  query InspectionPointSubTypesBySpkUnitSubTypeTblId(
    $spkUnitSubTypeTblId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelInspectionPointSubTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inspectionPointSubTypesBySpkUnitSubTypeTblId(
      spkUnitSubTypeTblId: $spkUnitSubTypeTblId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spkUnitSubTypeTblId
        spkUnitInspectionPointTblId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const inspectionPointSubTypesBySpkUnitInspectionPointTblId = /* GraphQL */ `
  query InspectionPointSubTypesBySpkUnitInspectionPointTblId(
    $spkUnitInspectionPointTblId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelInspectionPointSubTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inspectionPointSubTypesBySpkUnitInspectionPointTblId(
      spkUnitInspectionPointTblId: $spkUnitInspectionPointTblId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spkUnitSubTypeTblId
        spkUnitInspectionPointTblId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
